<app-nav></app-nav>

<ng-container *ngIf="lang.currentLang === 'es'">
    <section class="terms-item" lang="es">
        <div class="container">
            <div class="row">
                <div class="col col-md-2"></div>
                <div class="col-12 col-md-10">
                    <a class="terms-item-link" name="legal_tad"></a>
                    <h2>Términos y condiciones</h2>
                    <h3>1. Términos y condiciones</h3>
                    <p>Los siguientes Términos y Condiciones (el «Acuerdo») regulan su acceso y uso de nuestra
                        Plataforma en línea, a través de la cual puede prestarse un servicio de información destinado a
                        informarle sobre su nivel de ansiedad (conjuntamente, la «Plataforma»).</p>
                    <p>Este sitio web es propiedad de y está operado por Steel Blanket Technologies s.r.o., domicilio:
                        plaza I. P. Pavlova 1785/3, Ciudad Nueva, 120 00 Praga 2 (steelblanket.info@gmail.com).</p>
                    <p>El visitante del sitio web, la persona física o jurídica que utilice la Plataforma, incluido un
                        usuario registrado mediante un perfil de Google o mediante la creación de una cuenta, se
                        denomina «usted» o «Visitante».</p>
                    <p>La Plataforma se ofrece y pone a disposición de Visitantes de dieciocho (18) años o más.</p>
                    <p>Al acceder a la Plataforma o utilizarla, usted celebra este Acuerdo. Debe leerlo detenidamente
                        antes de comenzar a utilizar la Plataforma. Si no acepta quedar obligado por cualquiera de sus
                        términos, no debe acceder a la Plataforma.</p>
                    <p>Cuando en este Acuerdo se utilizan los términos «nosotros», «nos», «nuestro» u otros similares,
                        se refieren a la empresa propietaria y operadora de la Plataforma (la «Compañía»).</p>
                    <h3>2. Los asesores y los Servicios de Asesoramiento</h3>
                    <p>La Plataforma permite a los Visitantes utilizar servicios como la evaluación del nivel de
                        ansiedad.</p>
                    <p>La Plataforma puede utilizarse para informarle sobre su nivel de ansiedad o sobre la posible
                        existencia de síndromes postraumáticos.</p>
                    <p>Usted comprende y acepta que la Compañía no es una institución médica ni un proveedor de atención
                        sanitaria. No prestamos servicios profesionales propios de instituciones médicas o proveedores
                        de atención sanitaria.</p>
                    <p>La Plataforma no proporciona asesoramiento médico. Toda la información relacionada con la
                        medicina, incluidos, entre otros, los mensajes de texto, se ofrece únicamente con fines
                        informativos. Esta información no sustituye el asesoramiento, diagnóstico o tratamiento médico
                        profesional. Si tiene preguntas sobre una afección médica, consulte siempre a un médico u otro
                        profesional sanitario cualificado.</p>
                    <p>La información disponible en la Plataforma y a través de ella complementa, pero NO sustituye, los
                        conocimientos, la experiencia y el criterio de psiquiatras, psicólogos, médicos y demás
                        profesionales sanitarios cualificados. La información de la Plataforma se ha obtenido de fuentes
                        que se consideran cualificadas, precisas y fiables. No obstante, la Compañía no garantiza su
                        exactitud, fiabilidad ni integridad. Consulte a un médico u otro profesional sanitario si tiene
                        preguntas o inquietudes relacionadas con la salud, la medicina o una discapacidad. La
                        información a la que se accede en la Plataforma o a través de ella no es completa ni exhaustiva
                        y no abarca todos los recursos, trastornos y/o afecciones de salud mental, ni su manejo o
                        tratamiento. La información accesible en la Plataforma y a través de ella se proporciona «TAL
                        CUAL» y sin garantías expresas o implícitas, incluidas, entre otras, las garantías implícitas de
                        idoneidad para un fin determinado.</p>
                    <p><i>SI ESTÁ PENSANDO EN EL SUICIDIO O EN HACERSE DAÑO A SÍ MISMO O A OTRAS PERSONAS, SI CONSIDERA
                        QUE ALGUIEN PUEDE ESTAR EN PELIGRO O SI TIENE UNA EMERGENCIA MÉDICA, DEBE LLAMAR INMEDIATAMENTE
                        AL NÚMERO DE EMERGENCIAS (911) Y AVISAR A LAS AUTORIDADES CORRESPONDIENTES. BUSQUE ASISTENCIA
                        PRESENCIAL INMEDIATA. LA PLATAFORMA NO ESTÁ DISEÑADA PARA NINGUNA DE LAS SITUACIONES ANTERIORES
                        Y LOS ASESORES NO PUEDEN PROPORCIONAR LA AYUDA NECESARIA EN TALES CASOS. LA PLATAFORMA NO ESTÁ
                        DESTINADA A EMITIR DIAGNÓSTICOS CLÍNICOS QUE REQUIERAN UNA EVALUACIÓN PRESENCIAL, Y NO DEBE
                        UTILIZARLA SI NECESITA DOCUMENTACIÓN O AUTORIZACIONES OFICIALES PARA FINES COMO, ENTRE OTROS,
                        ASESORAMIENTO ORDENADO POR UN TRIBUNAL. TAMPOCO ESTÁ DESTINADA A PROPORCIONAR INFORMACIÓN SOBRE
                        QUÉ MEDICAMENTOS O TRATAMIENTOS MÉDICOS PUEDEN SER ADECUADOS PARA USTED, Y DEBE IGNORAR
                        CUALQUIER CONSEJO DE ESE TIPO RECIBIDO A TRAVÉS DE LA PLATAFORMA. NO DEJE DE OBTENER, EVITE NI
                        RETRASE LA ATENCIÓN PRESENCIAL DE SU MÉDICO U OTRO PROFESIONAL CUALIFICADO A CAUSA DE LA
                        INFORMACIÓN O LOS CONSEJOS RECIBIDOS A TRAVÉS DE LA PLATAFORMA.</i></p>
                    <h3>3. Privacidad y seguridad</h3>
                    <p>La protección y salvaguarda de toda la información que proporcione a través de la Plataforma es
                        extremadamente importante para nosotros.</p>
                    <p><i>AL ACEPTAR ESTE ACUERDO Y/O UTILIZAR LA PLATAFORMA, TAMBIÉN ACEPTA LOS TÉRMINOS DE LA POLÍTICA
                        DE PRIVACIDAD. LA POLÍTICA DE PRIVACIDAD SE INCORPORA A ESTE ACUERDO Y SE CONSIDERA PARTE DE ÉL.
                        LAS MISMAS NORMAS RELATIVAS A CAMBIOS Y REVISIONES DE ESTE ACUERDO SE APLICAN A LOS CAMBIOS Y
                        REVISIONES DE LA POLÍTICA DE PRIVACIDAD.</i></p>
                    <h3>4. Exclusión de garantías y limitación de responsabilidad</h3>
                    <p><i>POR MEDIO DEL PRESENTE, USTED NOS EXONERA Y ACEPTA MANTENERNOS INDEMNES FRENTE A CUALQUIER
                        ACCIÓN O RECLAMACIÓN DE CUALQUIER NATURALEZA DERIVADA DE LOS SERVICIOS DE LOS ASESORES O DE LA
                        PLATAFORMA, INCLUIDOS, ENTRE OTROS, CUALQUIER ACTO, OMISIÓN, OPINIÓN, RESPUESTA, CONSEJO,
                        SUGERENCIA, INFORMACIÓN Y/O SERVICIO DE CUALQUIER ASESOR, ASÍ COMO CUALQUIER OTRO CONTENIDO O
                        INFORMACIÓN ACCESIBLE A TRAVÉS DE LA PLATAFORMA. </i></p>
                    <p><i>USTED COMPRENDE, ACEPTA Y RECONOCE QUE LA PLATAFORMA SE PROPORCIONA «TAL CUAL», SIN GARANTÍAS
                        EXPRESAS O IMPLÍCITAS DE NINGÚN TIPO, INCLUIDAS, ENTRE OTRAS, LAS GARANTÍAS DE COMERCIABILIDAD,
                        NO INFRACCIÓN, SEGURIDAD, IDONEIDAD PARA UN FIN DETERMINADO O EXACTITUD. EL USO DE LA PLATAFORMA
                        CORRE POR SU CUENTA Y RIESGO. EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY, RECHAZAMOS EXPRESAMENTE
                        TODA GARANTÍA, YA SEA EXPRESA O IMPLÍCITA. USTED COMPRENDE, ACEPTA Y RECONOCE QUE NO SEREMOS
                        RESPONSABLES ANTE USTED NI ANTE TERCEROS POR DAÑOS INDIRECTOS, INCIDENTALES, CONSECUENTES,
                        ESPECIALES, PUNITIVOS O EJEMPLARES. En caso de que</i> la legislación aplicable no permita la
                        limitación de responsabilidad establecida anteriormente, dicha limitación se modificará
                        únicamente en la medida necesaria para cumplir la legislación aplicable. Esta sección seguirá
                        vigente tras la terminación o expiración de este Acuerdo.
                    </p>
                    <p><i>DETERMINADAS LEYES ESTATALES NO PERMITEN LIMITAR LAS GARANTÍAS IMPLÍCITAS. SI DICHAS LEYES LE
                        SON APLICABLES, ES POSIBLE QUE ALGUNAS O TODAS LAS EXCLUSIONES, EXENCIONES Y LIMITACIONES
                        ANTERIORES NO SE APLIQUEN A USTED, Y QUE DISPONGA DE DERECHOS ADICIONALES.</i></p>
                    <h3>5. Su cuenta, declaraciones, conducta y compromisos</h3>
                    <p>Cuando cree una cuenta para utilizar o acceder a determinadas partes de la Plataforma, deberá
                        proporcionar la información completa y exacta solicitada en el formulario de registro. Deberá
                        mantener y actualizar dicha información para que siga siendo completa y exacta. También se le
                        solicitará un nombre de usuario, una dirección de correo electrónico y una contraseña. Usted es
                        responsable de mantener la confidencialidad de su contraseña y de todas las actividades
                        —realizadas por usted o por otras personas— que tengan lugar mediante su contraseña o cuenta. No
                        podrá utilizar en ningún momento la cuenta, el nombre de usuario o la contraseña de un tercero,
                        ni permitirá que otra persona acceda a la Plataforma o la utilice desde su cuenta.</p>
                    <p>Por el presente, usted declara y garantiza a la Compañía que: (a) dispone de todos los derechos y
                        facultades necesarios para utilizar la Plataforma conforme a este Acuerdo y otorgar los derechos
                        aplicables aquí previstos; (b) es responsable de todo uso de la Plataforma asociado a su cuenta;
                        (c) es el único responsable de mantener la confidencialidad de los nombres de cuenta, correos
                        electrónicos y contraseñas; (d) acepta notificar inmediatamente a la Compañía cualquier uso no
                        autorizado de su cuenta del que tenga conocimiento; (e) acepta que la Compañía no será
                        responsable de las pérdidas derivadas del uso de su cuenta por parte de un tercero,
                        independientemente de que dicho uso se realice con o sin su conocimiento y consentimiento; (f)
                        utilizará la Plataforma únicamente con fines lícitos y de conformidad con este Acuerdo; (g) toda
                        información que envíe a través de la Plataforma será verdadera, exacta y correcta; y (h) no
                        intentará obtener acceso no autorizado a la Plataforma, otras cuentas, sistemas informáticos o
                        redes bajo el control o la responsabilidad de la Compañía mediante piratería informática,
                        vulneración de sistemas, obtención de contraseñas o cualquier otro medio no autorizado.</p>
                    <p>Por el presente, confirma que puede prestar legalmente su consentimiento para recibir los
                        Servicios o que cuenta con el consentimiento de un progenitor o tutor, y que puede celebrar
                        legalmente un contrato. Asimismo, confirma y acepta que toda la información que ha proporcionado
                        en la Plataforma o a través de ella, así como la que proporcione en el futuro, es exacta,
                        verdadera, actual y completa. Además, acepta mantener y actualizar dicha información durante la
                        vigencia de este Acuerdo para que continúe siendo exacta, actual y completa. Usted acepta,
                        confirma y reconoce que es responsable de mantener la confidencialidad de su contraseña y de
                        cualquier otra información de seguridad relacionada con su cuenta (conjuntamente, el «Acceso a
                        la cuenta»). Le recomendamos cambiar la contraseña con frecuencia y extremar las precauciones
                        para protegerla. Acepta notificarnos inmediatamente cualquier uso no autorizado de su Acceso a
                        la cuenta o cualquier otra posible vulneración de la seguridad de su cuenta. Acepta, confirma y
                        reconoce que no seremos responsables de pérdidas o daños derivados del uso de su cuenta por otra
                        persona, con o sin su consentimiento y/o conocimiento. Acepta, confirma y reconoce que es única
                        y plenamente responsable de todas las actividades realizadas mediante su Acceso a la cuenta.
                        Asimismo, reconoce y acepta que responderá por cualquier daño o pérdida ocasionados por el uso
                        de su Acceso a la cuenta por cualquier persona, esté o no autorizada por usted, y acepta
                        indemnizarnos por dichos daños o pérdidas. Se compromete a no utilizar la cuenta o el acceso a
                        la cuenta de otra persona por ningún motivo. Acepta y confirma el uso que realiza de la
                        Plataforma. Se compromete a no interferir, interrumpir ni intentar interferir o interrumpir
                        ninguno de nuestros sistemas, servicios, servidores, redes o infraestructuras, ni los de la
                        Plataforma, incluido, entre otros, el acceso no autorizado a cualquiera de ellos. Asimismo, se
                        compromete a no utilizar la Plataforma para publicar, enviar o entregar ninguno de los
                        siguientes elementos:</p>
                    <ol start="1" style="margin-top:0cm" type="1">
                        <li>Correo electrónico no solicitado y/o publicidad o promoción de bienes y servicios.</li>
                        <li>Software o código malicioso.</li>
                        <li>Contenido ilícito, acosador, invasivo de la privacidad, abusivo, amenazante, vulgar,
                            obsceno, racista o potencialmente perjudicial.
                        </li>
                        <li>Cualquier contenido que infrinja los derechos de un tercero, incluidos los derechos de
                            propiedad intelectual.
                        </li>
                        <li>Cualquier contenido que pueda causar daños a un tercero.</li>
                        <li>Cualquier contenido que pueda constituir, inducir o fomentar una conducta delictiva o
                            infringir la legislación aplicable.
                        </li>
                    </ol>
                    <p>Usted acepta y se compromete a no infringir ninguna ley, estatuto, ordenanza, norma, reglamento o
                        código ético local, estatal, nacional o internacional aplicable en relación con el uso de la
                        Plataforma. Usted nos indemnizará, defenderá y mantendrá indemnes frente a cualesquiera
                        reclamaciones, pérdidas, acciones, demandas, responsabilidades, costes o gastos —incluidos,
                        entre otros, los gastos procesales y los honorarios y gastos razonables de abogados— que surjan
                        de cualquiera de las siguientes circunstancias o estén relacionados con ellas:</p>
                    <ol start="1" style="margin-top:0cm" type="1">
                        <li>Su acceso a la Plataforma o el uso que haga de ella.</li>
                        <li>Cualquier acción realizada mediante su cuenta o Acceso a la cuenta, ya sea por usted o por
                            otra persona.
                        </li>
                        <li>El incumplimiento por su parte de cualquiera de las disposiciones de este Acuerdo.</li>
                        <li>La falta de pago de cualquiera de los servicios, incluidos los Servicios de Asesoramiento,
                            prestados a través de la Plataforma.
                        </li>
                        <li>La vulneración por su parte de cualquier derecho de terceros, incluidos, entre otros,
                            derechos de propiedad intelectual, publicidad, confidencialidad, propiedad o privacidad.
                        </li>
                    </ol>
                    <h3>6. Modificaciones, terminación, interrupción y alteraciones de la Plataforma.   </h3>
                    <p>Usted comprende, acepta y reconoce que podemos modificar, suspender, interrumpir o dejar de
                        ofrecer la Plataforma, cualquier parte de ella o su uso, ya sea para todos los clientes o
                        específicamente para usted, en cualquier momento y con o sin previo aviso. Acepta y reconoce que
                        no seremos responsables ante usted ni ante terceros por ninguna de las actuaciones anteriores ni
                        por la modificación, suspensión o interrupción de los Servicios de Asesoramiento, ni por las
                        pérdidas o daños causados por dichas actuaciones. La Plataforma depende de diversos factores,
                        como software, hardware y herramientas, ya sean propios o propiedad de nuestros contratistas y
                        proveedores, o gestionados por estos. Aunque realizamos esfuerzos comercialmente razonables para
                        garantizar la fiabilidad y accesibilidad de la Plataforma, usted comprende y acepta que ninguna
                        plataforma puede ser fiable y accesible al 100 %. Por tanto, no podemos garantizar que el acceso
                        a la Plataforma sea ininterrumpido ni que esté disponible de forma constante, oportuna y sin
                        errores.</p>
                    <h3>7. Notificaciones</h3>
                    <p>Podemos enviarle notificaciones u otras comunicaciones relativas a este Acuerdo o a cualquier
                        aspecto de la Plataforma mediante correo electrónico a la dirección que conste en nuestros
                        registros, correo postal ordinario o publicación en línea. La fecha de recepción se considerará
                        la fecha en que se efectúe la notificación. Las notificaciones dirigidas a nosotros deberán
                        enviarse por correo electrónico a questions@anima.help.</p>
                    <h3>8. Consideraciones importantes sobre nuestro Acuerdo</h3>
                    <p>Este Acuerdo y cualquier controversia que pueda surgir entre usted y la Compañía se interpretarán
                        exclusivamente de conformidad con las leyes del Estado de California y de los Estados Unidos de
                        América, sin tener en cuenta normas sobre conflicto de leyes ni otros principios que dispongan
                        la aplicación de la legislación de otra jurisdicción. <i>ESTE ACUERDO CONSTITUYE EL ACUERDO
                            ÍNTEGRO ENTRE USTED Y NOSOTROS. USTED CONFIRMA QUE NO HA CONFIADO EN NINGUNA PROMESA O
                            DECLARACIÓN NUESTRA SALVO LAS EXPRESAMENTE RECOGIDAS EN ESTE ACUERDO. </i>Podemos modificar
                        este Acuerdo publicando los cambios en la Plataforma. Salvo que indiquemos lo contrario, todos
                        los cambios surtirán efecto en el momento de su publicación. Por ello, le recomendamos revisar
                        con frecuencia los términos de este Acuerdo. La fecha de su última actualización figura al final
                        del Acuerdo. Al utilizar la Plataforma después de que los cambios entren en vigor, usted acepta
                        quedar vinculado por ellos. Si no está de acuerdo con los cambios, deberá dejar de acceder a la
                        Plataforma y de participar en sus servicios. Podemos transferir o ceder libremente este Acuerdo
                        o cualquiera de las obligaciones que contiene. Los encabezados de los apartados se incluyen
                        únicamente por comodidad y no se utilizarán para interpretar este Acuerdo. Si un tribunal
                        competente declara ilegal, inválida, inaplicable o contraria a la ley alguna disposición, las
                        restantes disposiciones permanecerán plenamente vigentes. Para evitar dudas, todas las cláusulas
                        relativas a limitaciones de responsabilidad e indemnización seguirán vigentes tras la
                        terminación o expiración de este Acuerdo.</p>
                    <h3>9. Derechos de propiedad intelectual</h3>
                    <p>La Plataforma contiene materiales protegidos y está amparada por las leyes de derechos de autor,
                        disposiciones de tratados internacionales, marcas comerciales, marcas de servicio y demás leyes
                        y tratados sobre propiedad intelectual. Salvo autorización expresa de los titulares de derechos,
                        ninguna parte de la Plataforma podrá copiarse, reproducirse, republicarse, descargarse,
                        cargarse, publicarse, mostrarse, transmitirse ni distribuirse. NADA DE LO CONTENIDO EN LA
                        PLATAFORMA SE INTERPRETARÁ COMO LA CONCESIÓN DE LICENCIA ALGUNA EN VIRTUD DE LOS DERECHOS DE
                        PROPIEDAD INTELECTUAL DE SUS TITULARES, YA SEA POR IMPEDIMENTO LEGAL, IMPLICACIÓN O CUALQUIER
                        OTRO MEDIO.</p>
                    <p>Al aceptar este Acuerdo, le concedemos acceso y el derecho a utilizar la Plataforma para sus
                        fines internos y únicamente en la medida expresamente permitida. No utilizará ni permitirá el
                        uso de la Plataforma con fines ilícitos ni de manera incompatible con las disposiciones de este
                        Acuerdo.</p>
                    <p>Usted reconoce que, salvo lo descrito en este Acuerdo, la información que nos proporcione o que
                        recopilemos se utilizará y protegerá conforme a la Política de Privacidad que figura a
                        continuación.</p>
                    <a class="terms-item-link" name="legal_pp"></a>
                    <h2>Política de Privacidad</h2>
                    <h3>1. Sobre su privacidad y esta Política de Privacidad</h3>
                    <p>Su privacidad es fundamental para nosotros. Dedicamos continuamente una atención, esfuerzo,
                        herramientas, recursos y procedimientos considerables a protegerla y salvaguardarla. Este
                        documento constituye nuestra «Política de Privacidad» y contiene información detallada sobre
                        cuestiones relacionadas con su privacidad al utilizar nuestros servicios. Esta Política de
                        Privacidad se aplica a los visitantes de los sitios web públicos propiedad de la Compañía y
                        operados por ella, así como a los usuarios registrados de la Plataforma. Su finalidad es
                        informarle sobre nuestras políticas, procedimientos y prácticas relativos a la recopilación, uso
                        y divulgación de la información que proporcione a través de la Plataforma. La Política de
                        Privacidad forma parte de nuestros Términos y Condiciones. Los términos utilizados en la
                        Política de Privacidad, incluidos, entre otros, «nosotros», «nuestro», «nos», «Plataforma» y
                        «Servicios de Asesoramiento», tienen el mismo significado que en el documento de Términos y
                        Condiciones. Al utilizar la Plataforma, usted acepta los Términos y Condiciones y la Política de
                        Privacidad. Si no acepta quedar vinculado por la Política de Privacidad, debe dejar de utilizar
                        la Plataforma inmediatamente. Al acceder a nuestra Plataforma y utilizarla, según corresponda,
                        declara que ha leído los Términos y Condiciones y la Política de Privacidad, y que comprende,
                        acepta y reconoce todos los términos incluidos en ambos documentos.</p>
                    <h3>2. Recopilación, uso y divulgación de información</h3>
                    <h3>Categorías de información recopilada</h3>
                    <p>Para que podamos operar la Plataforma de forma eficaz y permitirle utilizarla, podemos recopilar,
                        utilizar y almacenar la información que se describe a continuación. También divulgamos
                        determinada información a terceros, según se explica más adelante. La información que
                        recopilamos se recibe directa o indirectamente de usted y se genera durante el uso de la
                        Plataforma. Asimismo, recopilamos información generada al utilizar nuestros servicios e
                        información procedente de terceros, por ejemplo, cuando accede a nuestros servicios mediante su
                        inicio de sesión de Facebook o Google. Los datos recopilados no se utilizan con fines de
                        marketing ni con otros fines distintos de los especificados en esta Política de Privacidad. </p>
                    <p><b>Datos del Visitante:</b> La Compañía recopila, utiliza y almacena datos relativos a las
                        visitas de los usuarios a su sitio web y al uso de la Plataforma («Datos del Visitante»),
                        incluidas las páginas concretas visitadas o vistas por el usuario, el tiempo que este permanece
                        en el sitio web, los errores del sitio web que experimenta, las visitas a la página de
                        «Preguntas frecuentes» y la información sobre el navegador o dispositivo utilizado para acceder
                        al sitio web, como el identificador del dispositivo y la dirección IP del usuario.</p>
                    <p><b>Datos de incorporación:</b> Además de la información proporcionada por los usuarios a través
                        de la Plataforma, la Compañía recopila, utiliza y almacena determinados datos adicionales
                        durante el proceso de incorporación («Datos de incorporación»). Estos datos incluyen las páginas
                        vistas por el usuario y si este hace clic en el enlace «Comenzar» para iniciar la prueba.</p>
                    <p><b>Datos de registro de la cuenta:</b> La Compañía recopila, utiliza y almacena determinada
                        información relacionada con el proceso de registro de la cuenta, como si los usuarios se
                        registraron mediante sus perfiles de Google y si verificaron la dirección de correo electrónico
                        o el número de teléfono indicados («Datos de registro de la cuenta»). La Compañía también asigna
                        a cada usuario que crea una cuenta un identificador de cliente anonimizado y generado
                        secuencialmente.</p>
                    <p><b>Datos de transacciones:</b> La Compañía recopila, utiliza y almacena determinada información
                        sobre los pagos de los usuarios por sus servicios y las transacciones relacionadas en su sitio
                        web, por ejemplo, si un usuario completó el pago de los servicios, se registró mediante una
                        oferta de prueba, canceló o finalizó de otro modo una prueba, o completó una solicitud de ayuda
                        económica para los servicios («Datos de transacciones»).
                    </p>
                    <p><b>Datos de inicio de sesión:</b> La Compañía recopila, utiliza y almacena datos sobre los
                        inicios de sesión de usuarios registrados en la Plataforma y la actividad realizada durante
                        dichos inicios de sesión, como el momento en que un usuario inicia sesión, el número de mensajes
                        recibidos o enviados a través de la Plataforma durante esa sesión y si se le ha asignado, ha
                        iniciado o ha completado un objetivo de asesoramiento («Datos de inicio de sesión»). Estos datos
                        no incluyen el contenido de los mensajes enviados o recibidos por los usuarios ni el contenido
                        de los objetivos de asesoramiento.</p>
                    <p><b>Datos del cliente:</b> La Compañía recopila, utiliza y almacena determinados datos de los
                        usuarios que se han registrado en los servicios, como el nombre o apodo declarado por el
                        usuario, la edad, la dirección de correo electrónico, el número de teléfono y la información de
                        contacto de emergencia («Datos del cliente»).</p>
                    <p><b>Datos de comunicaciones:</b> La Compañía recopila, utiliza y almacena las comunicaciones entre
                        los usuarios y los especialistas de la Plataforma, así como entre los usuarios y el equipo de
                        atención al cliente de la Compañía («Datos de comunicaciones»). La protección de esta
                        información es fundamental para nosotros. Salvo en los casos detallados en esta Política de
                        Privacidad, nunca utilizaremos ni divulgaremos información alguna a menos que usted lo solicite
                        o lo autorice. Fines para los que se utiliza la información: podemos utilizar la información
                        recopilada para uno o varios de los siguientes fines:</p>
                    <h3>Comunicación con usted</h3>
                    <ul>
                        <li>Ponernos en contacto con usted o proporcionarle información, alertas y sugerencias
                            relacionadas con la Plataforma.
                        </li>
                        <li>Verificar su identidad.</li>
                        <li>Completar una actividad solicitada por usted, como registrarse en la Plataforma u obtener
                            más información.
                        </li>
                        <li>Ponernos en contacto con usted, directamente o a través de las autoridades competentes, si
                            tenemos motivos fundados para creer que usted u otra persona puede estar en peligro o puede
                            ser autor o víctima de un delito.
                        </li>
                    </ul>
                    <h3>Prestación de servicios</h3>
                    <ul>
                        <li>Crear su cuenta en nuestra Plataforma y permitirle iniciar sesión, acceder a ella y
                            utilizarla.
                        </li>
                        <li>Gestionar su cuenta, prestar atención al cliente y garantizar que reciba un servicio de
                            calidad.
                        </li>
                        <li>Realizar la facturación y el procesamiento de transacciones.</li>
                        <li>Proporcionar, mantener, personalizar y desarrollar nuestra Plataforma.</li>
                    </ul>
                    <h3>Administración y mejora de los servicios</h3>
                    <ul>
                        <li>Supervisar, administrar y controlar la Plataforma.</li>
                        <li>Medir y mejorar la calidad, eficacia y prestación de nuestros servicios.</li>
                    </ul>
                    <h3>Personalización</h3>
                    <ul>
                        <li>Personalizar la experiencia del sitio web y ofrecer contenidos, productos y servicios
                            pertinentes para los intereses individuales, incluidas ofertas y anuncios dirigidos.
                        </li>
                    </ul>
                    <h3>Cumplimiento de la ley</h3>
                    <ul>
                        <li>Responder a solicitudes de las fuerzas del orden cuando lo exijan la legislación aplicable,
                            una orden judicial o las normas gubernamentales.
                        </li>
                        <li>Cumplir las leyes estatales y federales aplicables, incluidas, entre otras, las relacionadas
                            con la protección de la salud y la seguridad de los clientes y del público.
                        </li>
                        <li>Permitir que los terapeutas cumplan los requisitos de licencia, legales y de calidad de sus
                            respectivas jurisdicciones.
                        </li>
                    </ul>
                    <h3>Otros usos con consentimiento</h3>
                    <ul>
                        <li>Cualquier otro fin con su consentimiento.</li>
                    </ul>
                    <h3>Fines para los que se divulga información a terceros</h3>
                    <p>La información sobre usted puede divulgarse a terceros para uno o varios de los siguientes
                        fines:</p>
                    <p><strong>Para fines comerciales:</strong> Podemos compartir su información con proveedores y
                        prestadores de servicios, incluidos nuestros socios de alojamiento y almacenamiento de datos,
                        proveedores de análisis y de servicios y asistencia tecnológica, procesamiento de pagos y
                        seguridad de datos. También podemos compartir información con asesores profesionales, como
                        auditores, bufetes de abogados y firmas de contabilidad.</p>
                    <p>Conforme a sus instrucciones o con su consentimiento: podemos compartir su información con
                        terceros si usted lo solicita o nos da instrucciones para ello.</p>
                    <p>Con empresas afiliadas de nuestro grupo corporativo: podemos compartir su información con
                        filiales o empresas matrices de nuestro grupo corporativo.</p>
                    <p><strong>Para publicidad:</strong> Si ha dado su consentimiento al uso de cookies de segmentación
                        y balizas web, la información relativa a su actividad en nuestros sitios web —excepto la
                        actividad realizada cuando ha iniciado sesión y ha comenzado una terapia— puede divulgarse a
                        nuestros socios publicitarios para optimizar el marketing. No compartimos con plataformas
                        publicitarias información privada como nombres de miembros, direcciones de correo electrónico,
                        números de teléfono, diagnósticos, datos de sesiones, entradas de diario, mensajes, hojas de
                        trabajo ni ningún otro tipo de comunicación con su terapeuta. Puede rechazar estas cookies y
                        balizas web. 
                    </p>
                    <p><b>Cumplimiento de la ley:</b> Podemos compartir su información con un tribunal, una autoridad
                        reguladora, personal de las fuerzas del orden o en virtud de una citación, para cumplir la
                        legislación aplicable o las obligaciones derivadas de ella.</p>
                    <p><strong>En el contexto de una transacción:</strong> Podemos compartir su información en relación
                        con la venta de activos, una fusión, una quiebra u otra operación empresarial.</p>
                    <p>Por otros motivos comerciales: podemos compartir su información para hacer cumplir cualesquiera
                        Términos y Condiciones aplicables y garantizar la seguridad de la Plataforma y de nuestros
                        usuarios. Tenga en cuenta que, si hace pública cualquier información en la Plataforma, cualquier
                        persona podrá verla y utilizarla.</p>
                    <h3>3. Baja de las comunicaciones de marketing</h3>
                    <p>Puede dejar de recibir correos electrónicos de marketing utilizando el enlace para cancelar la
                        suscripción incluido en dichas comunicaciones.</p>
                    <a class="" name="cookies"></a>
                    <h3>4. Cookies y balizas web</h3>
                    <p>Al igual que muchos sitios web, utilizamos «cookies» y «balizas web» (también conocidas como
                        píxeles) para recopilar información. Una «cookie» es un pequeño archivo de datos que se
                        transfiere al disco duro de su ordenador con fines de registro. Recopilamos cookies necesarias
                        para el funcionamiento de la Plataforma, cookies que mejoran su rendimiento y cookies utilizadas
                        para el seguimiento por terceros. Una «baliza web» es una imagen pequeña, en ocasiones
                        invisible, o un código incrustado en una página web o correo electrónico que puede informar a un
                        tercero sobre su visita o uso. Las balizas web suelen ser utilizadas por terceros para
                        supervisar la actividad de los usuarios en un sitio web con fines de analítica web, optimización
                        publicitaria o etiquetado de páginas. Puede encontrar información adicional sobre las balizas
                        web en Wikipedia. Puede cambiar la configuración de su navegador para dejar de aceptar cookies y
                        balizas web o para que le avise antes de aceptarlas. Uso de cookies, balizas web y tecnologías
                        similares para análisis: podemos utilizar cookies o balizas web de terceros para analítica web,
                        atribución y gestión de errores. Nuestra Plataforma puede utilizar servicios de proveedores que
                        emplean cookies, balizas web y tecnologías similares para recopilar y almacenar información
                        anónima sobre usted, incluidos los casos en que paga por servicios, carga una página, indica que
                        tuvo conocimiento de nosotros por televisión, se registra en los servicios, introduce sus datos
                        de pago —sin que se revelen los datos de pago—, inicia el cuestionario de admisión y responde
                        acerca de la fuente por la que llegó a la Plataforma. Nuestra Plataforma también utiliza
                        proveedores de análisis para recopilar información —por ejemplo, Datos del Visitante y Datos de
                        incorporación— sobre las acciones de los usuarios en nuestros sitios web, con fines de analítica
                        y análisis del uso específico de la Plataforma. Uso de cookies, balizas web y tecnologías
                        similares para redes publicitarias: si ha aceptado las cookies de segmentación y las balizas
                        web, usted y otras personas pueden ver determinados anuncios de nuestros servicios o de la
                        Plataforma en otros sitios web, ya que participamos en redes publicitarias. Estas redes nos
                        permiten dirigir mensajes a los usuarios según criterios demográficos, de intereses y
                        contextuales. Con el tiempo, las redes realizan un seguimiento de las actividades en línea de
                        las personas mediante la recopilación automatizada de información, incluidas cookies, registros
                        de servidores web y balizas web. Utilizan esta información para mostrar anuncios que pueden
                        adaptarse a los intereses de cada persona. Nuestras redes publicitarias pueden recopilar
                        información sobre sus visitas a sitios web participantes, como las páginas o anuncios que ve y
                        las acciones que realiza en ellos. Esta recopilación se produce tanto en nuestros sitios web
                        como en sitios web de terceros que participan en las redes publicitarias. El proceso también nos
                        ayuda a medir la eficacia de nuestras iniciativas de marketing y permite que otros sitios web y
                        socios publicitarios le encuentren a usted o a personas con características similares en
                        distintas plataformas, incluidas las redes sociales.</p>
                    <h3>5. Herramientas sociales y de información general</h3>
                    <p>Utilizamos varias herramientas y recursos de intercambio de información disponibles públicamente,
                        como, entre otros, un blog y Facebook (?). Cualquier información que proporcione o comparta al
                        utilizar las Herramientas sociales y de información general podrá ser leída, consultada y
                        recopilada por dicho sitio y por sus usuarios de conformidad con su Política de Privacidad.</p>
                    <h3>6. Suplantación de identidad</h3>
                    <p>El robo de identidad en línea y el acceso ilícito a cuentas, incluida la práctica conocida
                        actualmente como «phishing», son asuntos de gran preocupación. Debe actuar siempre con
                        diligencia cuando se le solicite información de su cuenta y asegurarse de proporcionarla
                        únicamente dentro de nuestro sistema seguro. Nunca le solicitaremos sus datos de inicio de
                        sesión o tarjeta de crédito mediante comunicaciones no seguras o no solicitadas, ya sea por
                        correo electrónico, teléfono u otros medios.</p>
                    <h3>7. Seguridad de la información</h3>
                    <p>Adoptamos medidas comercialmente razonables para proteger la integridad y confidencialidad de la
                        información sanitaria personalmente identificable que pueda compartir con nosotros. Tenga en
                        cuenta que ninguna medida de seguridad es perfecta o impenetrable y que no podemos garantizar la
                        seguridad absoluta de su información. Nosotros haremos nuestra parte para protegerla, pero usted
                        también debe proteger sus datos. Además, no controlamos las acciones de las personas con las que
                        usted u otro usuario de la Plataforma decidan compartir información. Por ello, debe actuar con
                        cautela respecto al acceso que concede a otras personas y a los datos que decide compartir al
                        utilizar la Plataforma.</p>
                    <h3>8. Proveedores de servicios</h3>
                    <p>Podemos contratar a empresas y personas terceras para facilitar el funcionamiento de la
                        Plataforma, realizar tareas específicas relacionadas con ella o prestarnos servicios de
                        auditoría, jurídicos, operativos o de otra índole. Estas tareas incluyen, entre otras, atención
                        al cliente, mantenimiento técnico, supervisión, gestión y comunicaciones por correo electrónico,
                        gestión de bases de datos, facturación y procesamiento de pagos, elaboración de informes y
                        análisis. Solo compartiremos con dichas partes la información mínima necesaria para realizar sus
                        tareas y únicamente después de celebrar un acuerdo de confidencialidad adecuado.</p>
                    <p>Nosotros o terceros podemos proporcionar enlaces a otros sitios web, servicios o recursos de
                        terceros que estén fuera de nuestro control. No formulamos declaraciones ni avales respecto de
                        la calidad, idoneidad, funcionalidad o legalidad de los contenidos de terceros a los que puedan
                        conducir dichos enlaces. Por el presente, usted renuncia a cualquier reclamación que pudiera
                        tener contra nosotros por tales servicios. LA COMPAÑÍA NO ES RESPONSABLE DEL CONTENIDO DE
                        INTERNET NI DE LAS PÁGINAS WEB SITUADAS FUERA DE LA PLATAFORMA.</p>
                    <p>Sus relaciones comerciales con terceros encontrados en la Plataforma o a través de ella,
                        incluidos los pagos y cualesquiera otros términos, condiciones, garantías o declaraciones
                        asociados a dichas relaciones, se establecen exclusivamente entre usted y el tercero
                        correspondiente. Usted acepta que no somos responsables de las pérdidas o daños derivados de
                        tales transacciones, de la presencia de dicho tercero o de enlaces a sitios web o recursos de
                        terceros incluidos en la Plataforma.</p>
                    <h3>9. Cumplimiento de las leyes y cooperación con las fuerzas del orden</h3>
                    <p>Cooperamos con las autoridades gubernamentales y las fuerzas del orden para hacer cumplir y
                        cumplir la ley. Podemos divulgar la información necesaria o adecuada para proteger la seguridad
                        del público o de cualquier persona, responder a reclamaciones y procedimientos legales
                        —incluidas, entre otras, citaciones— y prevenir o detener actividades que puedan ser ilegales o
                        peligrosas. También debe saber que nuestros especialistas pueden estar obligados a divulgar
                        información a las fuerzas del orden u otras autoridades para cumplir sus responsabilidades
                        profesionales y legales. En particular, y sin carácter limitativo, debe saber que la ley exige a
                        los profesionales de la salud mental divulgar información y/o adoptar medidas en los siguientes
                        casos:</p>
                    <ol start="1" style="margin-top:0cm" type="1">
                        <li>Denuncia o sospecha de maltrato de un menor o adulto vulnerable.</li>
                        <li>Riesgo grave de suicidio.</li>
                        <li>Amenaza de daño a otra persona.</li>
                        <li>Presentación de tratamiento por orden judicial.</li>
                    </ol>
                    <h3>10. Cambios en la Política de Privacidad</h3>
                    <p>Podemos actualizar esta declaración de privacidad a nuestra entera discreción. La fecha de la
                        última revisión figura al final de esta página. Le recomendamos consultar periódicamente esta
                        página para obtener la información más reciente sobre nuestra Política de Privacidad y nuestras
                        prácticas. Con independencia de cualquier cambio en la Política de Privacidad, nunca
                        utilizaremos la información que haya enviado al amparo del aviso de privacidad vigente de una
                        forma nueva sin notificárselo previamente y darle la opción de dejar de utilizar la
                        Plataforma.</p>
                    <h3>11. Contacto</h3>
                    <p>Si tiene preguntas o inquietudes sobre esta Política de Privacidad o nuestras prácticas
                        relacionadas con la privacidad, póngase en contacto con nosotros en questions@anima.help. Para
                        colaborar con nosotros, puede escribir a cooperation@anima.help.</p>
                    <a class="terms-item-link" name="legal_npp"></a>
                    <h2>Aviso sobre prácticas de privacidad</h2>
                    <p>Podemos recopilar los siguientes tipos de información cuando utiliza los Servicios:</p>
                    <p>Información que nos proporciona directamente. Para determinadas actividades, como registrarse,
                        utilizar nuestros servicios de telemedicina, suscribirse a nuestras alertas o ponerse en
                        contacto directamente con nosotros, podemos recopilar algunos o todos los siguientes tipos de
                        información:</p>
                    <ul>
                        <li>Datos de contacto, como su nombre completo, dirección de correo electrónico y número de
                            teléfono móvil;
                        </li>
                        <li>Nombre de usuario y contraseña;</li>
                        <li>Información de pago, como el número de su tarjeta de crédito, la fecha de caducidad y el
                            código de seguridad;
                        </li>
                        <li>Información personal de salud;</li>
                        <li>Cualquier otra información que nos proporcione.</li>
                    </ul>
                    <p>Podemos combinar dicha información con la que ya tengamos sobre usted.</p>
                    <p>Información que recopilamos automáticamente. Podemos recopilar automáticamente determinada
                        información cuando utiliza nuestros Servicios, como su dirección de protocolo de Internet (IP),
                        identificadores del dispositivo y publicitarios, tipo de navegador, sistema operativo, proveedor
                        de servicios de Internet, páginas que visita antes y después de utilizar los Servicios, fecha y
                        hora de su visita, información sobre los enlaces en los que hace clic y las páginas que consulta
                        dentro de los Servicios, y otros datos estándar de registro del servidor. También podemos
                        recopilar información de ubicación cuando utiliza nuestros Servicios, como la dirección IP de su
                        ordenador, la señal GPS de su dispositivo móvil o información sobre puntos de acceso Wi-Fi y
                        torres de telefonía cercanos.</p>
                    <p>Podemos utilizar cookies, etiquetas de píxel, objetos compartidos locales y tecnologías similares
                        para recopilar esta información automáticamente. Al utilizar los Servicios, consiente nuestro
                        uso de cookies y tecnologías similares.</p>
                    <p>También podemos recopilar datos técnicos para abordar y resolver problemas técnicos y mejorar
                        nuestros Servicios, incluido el estado de la memoria de su dispositivo cuando se produce un
                        fallo del sistema o de una aplicación durante el uso de los Servicios. La configuración de su
                        dispositivo o navegador puede permitirle controlar la recopilación de estos datos técnicos.
                        Estos datos pueden incluir partes de un documento que haya utilizado o el contenido de sus
                        comunicaciones cuando se produjo un problema. Al utilizar los Servicios, consiente la
                        recopilación de estos datos técnicos.</p>
                    <p>Información que obtenemos de sus proveedores de atención sanitaria y de otras fuentes.</p>
                    <h3>Uso de la información</h3>
                    <p>Por lo general, utilizamos la información que recopilamos en línea para:</p>
                    <ul>
                        <li>Prestar y mejorar los Servicios;</li>
                        <li>Ponernos en contacto con usted;</li>
                        <li>Atender sus solicitudes de productos, servicios e información;</li>
                        <li>Enviarle información sobre servicios adicionales o bienestar general, directamente o en
                            nombre de nuestras empresas afiliadas y socios terceros de confianza;
                        </li>
                        <li>Analizar el uso de los Servicios y los datos de los usuarios para comprender y mejorar los
                            Servicios;
                        </li>
                        <li>Personalizar el contenido que ve cuando utiliza los Servicios;</li>
                        <li>Realizar investigaciones utilizando su información, lo que puede estar sujeto a una
                            autorización escrita independiente;
                        </li>
                        <li>Prevenir actividades potencialmente prohibidas o ilegales y actuar de conformidad con
                            nuestros Términos de Uso;
                        </li>
                        <li>Cualquier otro fin que se le comunique cuando recopilemos su información o que cuente con su
                            consentimiento.
                        </li>
                    </ul>
                    <h3>Divulgación de información</h3>
                    <p>Nos comprometemos a mantener su confianza y queremos que comprenda cuándo y con quién podemos
                        compartir la información que recopilamos.</p>
                    <ul>
                        <li>Proveedores de atención sanitaria, compañías de seguros y otras entidades relacionadas con
                            la atención sanitaria. Podemos compartir su información con otros proveedores de servicios,
                            organismos, empresas u organizaciones.
                        </li>
                        <li>Proveedores y prestadores de servicios terceros autorizados. Podemos compartir su
                            información con proveedores y prestadores de servicios terceros que nos ayudan a ofrecer
                            servicios especializados, entre ellos facturación, procesamiento de pagos, atención al
                            cliente, envío de correos electrónicos, análisis empresarial, marketing —incluidos, entre
                            otros, publicidad, atribución, marketing móvil, optimización y retargeting—, supervisión del
                            rendimiento, alojamiento y procesamiento de datos. Estos terceros no podrán utilizar su
                            información para fines distintos de los relacionados con los servicios que nos prestan.
                        </li>
                        <li>Socios de investigación. Podemos compartir su información con nuestros socios de
                            investigación para realizar estudios relacionados con la salud; dicho intercambio puede
                            estar sujeto a su autorización por escrito.
                        </li>
                        <li>Empresas afiliadas. Podemos compartir su información con nuestras empresas afiliadas de
                            conformidad con esta política.
                        </li>
                        <li>Transmisiones empresariales. Podemos compartir su información en relación con una operación
                            corporativa importante, como la venta de un sitio web, una fusión, consolidación, venta de
                            activos o, en el improbable caso, una quiebra.
                        </li>
                        <li>Fines legales. Podemos divulgar información para responder a citaciones, órdenes judiciales,
                            procedimientos legales, solicitudes de las fuerzas del orden, reclamaciones legales o
                            consultas gubernamentales, y para proteger y defender los derechos, intereses, salud,
                            seguridad y protección de nuestros usuarios o del público. Si estamos legalmente obligados a
                            divulgar información sobre usted a un tercero, intentaremos notificárselo mediante un correo
                            electrónico enviado a la dirección que conste en nuestros registros, salvo que hacerlo
                            infrinja la ley o que usted no nos haya proporcionado una dirección de correo electrónico.
                        </li>
                        <li>Con su consentimiento o siguiendo sus instrucciones. Podemos compartir información para
                            cualquier otro fin que se le comunique en el momento de recopilarla o que cuente con su
                            consentimiento o instrucciones.
                        </li>
                    </ul>
                    <p>Fuera de los supuestos especificados anteriormente, no proporcionaremos su información a
                        terceros. No obstante, puede utilizar servicios de acceso de terceros, como Facebook o Google, a
                        través de los Servicios para iniciar sesión o compartir con otras personas información sobre su
                        experiencia. Estos servicios de terceros pueden recopilar información sobre usted, incluida su
                        actividad en el Sitio, y pueden notificar a sus contactos el uso que haga del Sitio de
                        conformidad con sus propias políticas de privacidad.</p>
                    <p>Si participa en actividades públicas en el Sitio o en sitios de terceros a los que enlazamos,
                        debe saber que cualquier información que comparta allí puede ser leída, recopilada o utilizada
                        por otros usuarios de esas áreas. Debe actuar con precaución al divulgar información personal en
                        dichos sitios. No somos responsables de los datos que decida enviar a estas áreas públicas.</p>
                    <h3>Seguridad</h3>
                    <p>Utilizamos medidas razonables para ayudar a proteger la información frente a pérdidas, robos,
                        usos indebidos, accesos no autorizados, divulgaciones, alteraciones y destrucción. Debe
                        comprender que ningún sistema de almacenamiento de datos ni transmisión de datos a través de
                        Internet u otra red pública puede garantizarse como seguro al 100 %. Tenga en cuenta que la
                        información recopilada por terceros puede no contar con las mismas protecciones de seguridad que
                        la información que nos envía, y no somos responsables de proteger la seguridad de dicha
                        información.</p>
                    <a class="terms-item-link" name="legal_nnd"></a>
                    <h2>Aviso de no discriminación</h2>
                    <p>La Compañía no discrimina ni permite la discriminación, incluidos, entre otros, el acoso escolar,
                        el abuso o el hostigamiento, por motivos de raza, color, religión, origen nacional, ascendencia,
                        edad, género, discapacidad física o mental, orientación sexual, identidad o expresión de género
                        o estado serológico respecto del VIH, ya sean reales o percibidos; tampoco por la asociación con
                        otra persona debido a la raza, color, religión, origen nacional, ascendencia, edad, género,
                        discapacidad física o mental, orientación sexual, identidad o expresión de género o estado
                        serológico respecto del VIH, reales o percibidos, de dicha persona.</p>
                    <p>Fecha de entrada en vigor: 21 de agosto de 2022</p>
                </div>
            </div>
        </div>
    </section>
</ng-container>
<ng-container *ngIf="lang.currentLang === 'en'">
    <section class="terms-item" lang="en">
        <div class="container">
            <div class="row">
                <div class="col col-md-2"></div>
                <div class="col-12 col-md-10">
                    <a name="legal_tad" class="terms-item-link"></a>
                    <h2>The Terms and Conditions</h2>

                    <h3>1. The terms and conditions</h3>

                    <p>The following are the Terms and Conditions (the &quot;Agreement&quot;) which govern your access
                        and
                        use of our online Platform through which information service aims to inform you on your level of
                        anxiety may be provided (collectively the &quot;Platform&quot;).</p>

                    <p>This website is owned and operated by Steel Blanket Technologies s.r.o., address: square I. P.
                        Pavlova 1785/3, New Town, 120 00 Prague 2, (steelblanket.info@gmail.com).</p>

                    <p>Website visitor, individual or entity who uses the Platform, including a user registered using a
                        Google profile or creating an account, is referred to as &quot;you&quot; or
                        &quot;Visitor.&quot;</p>

                    <p>The Platform is offered and made available to Visitors who are eighteen (18) &nbsp;years of age
                        or
                        older.</p>

                    <p>By accessing or using the Platform, you are entering into this Agreement. You should read this
                        Agreement carefully before starting to use the Platform. If you disagree to be bound to any term
                        of
                        this Agreement, you must not access the Platform.</p>

                    <p>When the terms &quot;we,&quot; &quot;us,&quot; &quot;our,&quot; or similar are used in this
                        Agreement, they refer to the Company that owns and operates the Platform (the
                        &quot;Company&quot;).</p>

                    <h3>2. The Counselors and Counselor Services</h3>

                    <p>The Platform allows Visitors to take services, such as testing the level of anxiety.</p>

                    <p>The Platform may be used to inform you about your level of anxiety or the existence of
                        post-traumatic
                        syndromes.</p>

                    <p>You understand and agree that the Company is not a medical institution or medical health
                        provider. We
                        do not provide professional services by medical institutions or medical health providers.</p>

                    <p>The Platform does not provide medical advice. All medically related information, including,
                        without
                        limitation, text messages, is for informational purposes only. This information does not replace
                        professional medical advice, diagnosis, or treatment. If you have questions about a medical
                        condition, always seek the advice of a doctor or other qualified health professional.</p>

                    <p>The information available on and through the Platform is a supplement to, and NOT a substitute
                        for,
                        the knowledge, skill, and judgment of qualified psychiatrists, psychologists, physicians, and
                        health
                        care professionals. The information on the Platform has been obtained from sources believed to
                        be
                        qualified, accurate, and reliable. However, Company makes no warranty on this information&#39;s
                        accuracy, reliability, or completeness. Please consult a physician or other health care
                        professional
                        if you have health, medical, or disability questions or concerns. Information accessed on or
                        through
                        the Platform is neither complete nor exhaustive and does not cover all mental resources,
                        illnesses,
                        and/or conditions or their management or treatment. Information accessed on and through Platform
                        is
                        provided &quot;AS IS&quot; and without warranty, express or implied, including, but not limited
                        to,
                        any implied warranty of fitness for a particular purpose.</p>

                    <p><i>IF YOU ARE THINKING ABOUT SUICIDE OR CONSIDERING HARMING YOURSELF OR OTHERS, IF YOU FEEL ANY
                        OTHER
                        PERSON MAY BE IN ANY DANGER, OR IF YOU HAVE ANY MEDICAL EMERGENCY, YOU MUST IMMEDIATELY CALL THE
                        EMERGENCY SERVICE NUMBER (911) AND NOTIFY THE RELEVANT AUTHORITIES. SEEK IMMEDIATE IN-PERSON
                        ASSISTANCE. THE PLATFORM IS NOT DESIGNED FOR USE IN ANY OF THE MENTIONED ABOVE, AND THE
                        COUNSELORS
                        CAN NOT PROVIDE THE ASSISTANCE REQUIRED IN ANY OF THE CASES MENTIONED ABOVE. THE PLATFORM IS NOT
                        INTENDED FOR THE PROVISION OF CLINICAL DIAGNOSIS REQUIRING AN IN-PERSON EVALUATION, AND YOU
                        SHOULD
                        NOT USE IT IF YOU NEED ANY OFFICIAL DOCUMENTATION OR APPROVALS FOR PURPOSES SUCH AS, BUT NOT
                        LIMITED
                        TO, COURT-ORDERED COUNSELING. IT IS ALSO NOT INTENDED FOR ANY INFORMATION REGARDING WHICH DRUGS
                        OR
                        MEDICAL TREATMENT MAY BE APPROPRIATE FOR YOU, AND YOU SHOULD DISREGARD ANY SUCH ADVICE IF
                        DELIVERED
                        THROUGH THE PLATFORM. DO NOT DISREGARD, AVOID, OR DELAY IN OBTAINING IN-PERSON CARE FROM YOUR
                        DOCTOR
                        OR OTHER QUALIFIED PROFESSIONAL BECAUSE OF THE INFORMATION OR ADVICE YOU RECEIVED THROUGH THE
                        PLATFORM.</i></p>

                    <h3>3. Privacy and Security</h3>

                    <p>Protecting and safeguarding any information you provide through the Platform is extremely
                        important
                        to us.</p>

                    <p><i>BY AGREEING TO THIS AGREEMENT AND/OR USING THE PLATFORM, YOU ALSO AGREE TO THE PRIVACY POLICY
                        TERMS. THE PRIVACY POLICY IS INCORPORATED INTO AND DEEMED A PART OF THIS AGREEMENT. THE SAME
                        RULES
                        APPLY REGARDING CHANGES AND REVISIONS OF THIS AGREEMENT AND APPLY TO CHANGES AND REVISIONS OF
                        THE
                        PRIVACY POLICY.</i></p>

                    <h3>4. Disclaimer of Warranty and Limitation of Liability</h3>

                    <p><i>YOU HEREBY RELEASE US AND AGREE TO HOLD US HARMLESS FROM ANY AND ALL CAUSES OF ACTION AND
                        CLAIMS
                        OF ANY NATURE RESULTING FROM THE COUNSELOR&#39;S SERVICES OR THE PLATFORM, INCLUDING (WITHOUT
                        LIMITATION) ANY ACT, OMISSION, OPINION, RESPONSE, ADVICE, SUGGESTION, INFORMATION AND/OR SERVICE
                        OF
                        ANY COUNSELOR AND/OR ANY OTHER CONTENT OR INFORMATION ACCESSIBLE THROUGH THE PLATFORM. </i></p>

                    <p><i>YOU UNDERSTAND, AGREE, AND ACKNOWLEDGE THAT THE PLATFORM IS PROVIDED &quot;AS IS&quot; WITHOUT
                        ANY
                        EXPRESS OR IMPLIED WARRANTIES OF ANY KIND, INCLUDING BUT NOT LIMITED TO MERCHANTABILITY,
                        NON-INFRINGEMENT, SECURITY, FITNESS FOR A PARTICULAR PURPOSE, OR ACCURACY. THE USE OF THE
                        PLATFORM
                        IS AT YOUR OWN RISK. TO THE FULLEST EXTENT OF THE LAW, WE EXPRESSLY DISCLAIM ALL WARRANTIES OF
                        ANY
                        KIND, WHETHER EXPRESSED OR IMPLIED. YOU UNDERSTAND, AGREE, AND ACKNOWLEDGE THAT WE SHALL NOT BE
                        LIABLE TO YOU OR ANY THIRD PARTY FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE,
                        OR
                        EXEMPLARY DAMAGES. Suppose</i> the applicable law does not allow the limitation of liability as
                        set
                        forth above. In that case, the limitation will be modified solely to the extent necessary to
                        comply
                        with the applicable law. This section shall survive the termination or expiration of this
                        Agreement.
                    </p>

                    <p><i>CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES. IF THESE LAWS APPLY TO YOU,
                        SOME OR ALL OF THE FOREGOING DISCLAIMERS, EXCLUSIONS, AND LIMITATIONS MAY NOT APPLY TO YOU, AND
                        YOU
                        MIGHT HAVE ADDITIONAL RIGHTS.</i></p>

                    <h3>5. Your account, representations, conduct, and commitments</h3>

                    <p>When you create an account to use or access certain portions of the Platform, you must provide
                        complete and accurate information as requested on the registration form. You must maintain and
                        update such information to keep it complete and accurate. You will also be asked to provide a
                        user
                        name, email, and password. You are responsible for maintaining your password&#39;s
                        confidentiality
                        and for all activities (whether by you or others) that occur under your password or account. You
                        may
                        not use a third party&#39;s account, user name, or password at any time, and you will not allow
                        anyone to access or use the Platform from your account.</p>

                    <p>You hereby represent and warrant to the Company that: (a) you have all requisite rights and
                        authority
                        to use the Platform under this Agreement and to grant all applicable rights herein; (b) you are
                        responsible for all use of the Platform associated with its account; (c) you are solely
                        responsible
                        for maintaining the confidentiality of its account names, emails and password(s); (d) you agree
                        to
                        immediately notify the Company of any unauthorized use of your account of which you becomes
                        aware;
                        (e) you agree that the Company will not be liable for any losses incurred as a result of a third
                        party&#39;s use of your account, regardless of whether such use is with or without your
                        knowledge
                        and consent; (f) you will use the Platform for lawful purposes only and subject to this
                        Agreement;
                        (g) any information you submit through Platform is true, accurate, and correct; and (h) you will
                        not
                        attempt to gain unauthorized access to the Platform, other accounts, computer systems, or
                        networks
                        under the control or responsibility of the Company through hacking, cracking, password mining,
                        or
                        any other unauthorized means.</p>

                    <p>You hereby confirm that you can legally consent to receive Services or have the consent of a
                        parent
                        or guardian and that you can legally enter into a contract. You hereby confirm and agree that
                        all
                        the information you provided in or through the Platform, and the information you will provide in
                        or
                        through the Platform in the future, is accurate, true, current, and complete. Furthermore, you
                        agree
                        that during this Agreement, you will make sure to maintain and update this information so it
                        will
                        continue to be accurate, current, and complete. You agree, confirm and acknowledge that you are
                        responsible for maintaining the confidentiality of your password and any other security
                        information
                        related to your account (collectively &quot;Account Access&quot;). We advise you to change your
                        password frequently and to take extra care in safeguarding your password. You agree to notify us
                        immediately of any unauthorized use of your Account Access or any other concern for breach of
                        your
                        account security. You agree, confirm and acknowledge that we will not be liable for any loss or
                        damage incurred from someone else using your account, either with or without your consent and/or
                        knowledge. You agree, confirm and acknowledge that you are solely and entirely liable and
                        responsible for all activities performed using your Account Access. You further acknowledge and
                        agree that we will hold you liable and responsible for any damage or loss incurred from using
                        your
                        Account Access by any person, whether authorized by you or not, and you agree to indemnify us
                        for
                        any such damage or loss. You agree and commit not to use any other person&#39;s account or
                        account
                        access for any reason. You agree and confirm your use of the Platform. You agree and commit not
                        to
                        interfere with or disrupt, or attempt to interfere with or disrupt, any of our systems,
                        services,
                        servers, networks, or infrastructure, or any of the Platform&#39;s systems, services, servers,
                        networks, or infrastructure, including without limitation obtaining unauthorized access to those
                        mentioned above. You agree and commit not to make any use of the Platform for the posting,
                        sending,
                        or delivery of either of the following:</p>

                    <ol start="1" style="margin-top:0cm" type="1">
                        <li>Unsolicited email and/or advertisement or promotion of goods and services.</li>
                        <li>Malicious software or code.</li>
                        <li>Unlawful, harassing, privacy invading, abusive, threatening, vulgar, obscene, racist, or
                            potentially harmful content.
                        </li>
                        <li>Any content infringes a third party&#39;s right, including intellectual property rights.
                        </li>
                        <li>Any content that may cause damage to a third party.</li>
                        <li>Any content which may constitute, induce or encourage a criminal action or violate any
                            applicable law.
                        </li>
                    </ol>

                    <p>You agree and commit not to violate any applicable local, state, national or international law,
                        statute, ordinance, rule, regulation, or ethical code concerning your use of the Platform. You
                        will
                        indemnify us, defend us, and hold us harmless from and against all claims, losses, causes of
                        action,
                        demands, liabilities, costs, or expenses (including, but not limited to, litigation and
                        reasonable
                        attorneys&#39; fees and expenses) arising out of or relating to any of the following:</p>

                    <ol start="1" style="margin-top:0cm" type="1">
                        <li>Your access to or use of the Platform.</li>
                        <li>Any actions are made with your account or account access, whether by you or someone else.
                        </li>
                        <li>Your violation of any of the provisions of this Agreement.</li>
                        <li>Non-payment for any of the services (including Counselor Services) which were provided
                            through
                            the Platform.
                        </li>
                        <li>You violate any third party right, including, without limitation, any intellectual property
                            right, publicity, confidentiality, property, or privacy right.
                        </li>
                    </ol>

                    <h3>6. Modifications, Termination, Interruption, and Disruptions to the
                        Platform.&nbsp;&nbsp;&nbsp;</h3>

                    <p>You understand, agree, and acknowledge that we may modify, suspend, disrupt or discontinue the
                        Platform, any part of the Platform, or the use of the Platform, whether to all clients or you
                        specifically, at any time with or without notice to you. You agree and acknowledge that we will
                        not
                        be liable to you or any third party for any actions mentioned above or any modification,
                        suspension,
                        or discontinuance of the Counselor Services for any losses or damages caused by any of the
                        activities mentioned above. The Platform depends on various factors such as software, hardware,
                        and
                        tools, either our own or those owned and/or operated by our contractors and suppliers. While we
                        make
                        commercially reasonable efforts to ensure the Platform&#39;s reliability and accessibility, you
                        understand and agree that no platform can be 100% reliable and accessible. So we cannot
                        guarantee
                        that access to the Platform will be uninterrupted or that it will be accessible, consistent,
                        timely,
                        or error-free at all times.</p>

                    <h3>7. Notices</h3>

                    <p>We may provide notices or other communications to you regarding this Agreement or any aspect of
                        the
                        Platform by emailing the email address we have on record, by regular mail, or by posting it
                        online.
                        The date of receipt shall be deemed the date on which such notice is given. Notices sent to us
                        must
                        be delivered by email to questions@anima.help</p>

                    <h3>8. Important notes about our Agreement</h3>

                    <p>This Agreement and any dispute that might arise between you and the Company will be interpreted
                        solely under the laws of the State of California and the United States of America without regard
                        to
                        any conflict of law or other principles that provide for the application of the law of another
                        jurisdiction. <i>THIS AGREEMENT CONSTITUTES THE ENTIRE AGREEMENT BETWEEN YOU AND US. YOU CONFIRM
                            THAT YOU HAVE NOT RELIED UPON ANY PROMISES OR REPRESENTATIONS BY US EXCEPT AS OUTLINED IN
                            THIS
                            AGREEMENT. </i>We may change this Agreement by posting modifications on the Platform. Unless
                        otherwise specified by us, all modifications shall be effective upon posting. Therefore, you are
                        encouraged to check the terms of this Agreement frequently. The last update date of this
                        Agreement
                        is posted at the bottom of the Agreement. You agree to be bound by such changes to the Agreement
                        by
                        using the Platform after the changes become effective. If you do not agree to the changes, you
                        must
                        terminate the Platform&#39;s access and participation in its services. We may freely transfer or
                        assign this Agreement or any of its obligations hereunder. The paragraph headings in this
                        Agreement
                        are solely for convenience and will not be applied in interpreting this Agreement. Suppose any
                        provision of this Agreement is held by a court of competent jurisdiction to be illegal, invalid,
                        unenforceable, or otherwise contrary to law. In that case, the remaining provisions of this
                        Agreement will remain in full force and effect. To clear any doubt, all clauses regarding
                        limitations of liabilities and indemnification shall survive the termination or expiration of
                        this
                        Agreement.</p>

                    <h3>9. Intellectual Property Rights</h3>

                    <p>The Platform contains proprietary materials and is protected by copyright laws, international
                        treaty
                        provisions, trademarks, service marks, and other intellectual property laws and treaties. Except
                        as
                        otherwise expressly provided by rights holders, none of the Platform may be copied, reproduced,
                        republished, downloaded, uploaded, posted, displayed, transmitted, or distributed. NOTHING ON
                        THE
                        PLATFORM SHALL BE CONSTRUED TO CONFER ANY LICENSE UNDER ANY OF THE RIGHTS HOLDER&#39;S
                        INTELLECTUAL
                        PROPERTY RIGHTS, WHETHER BY ESTOPPEL, IMPLICATION, OR OTHERWISE.</p>

                    <p>Upon your acceptance of this Agreement, we grant you to access and right to use the Platform for
                        your
                        internal purposes and only as expressly permitted. You shall not use or permit the use of the
                        Platform for any illegal purpose or in any manner inconsistent with the provisions of this
                        Agreement.</p>

                    <p>You acknowledge that, except as described in this Agreement, the information you provide to us or
                        that we collect will be used and protected as described in the Privacy Policy below.</p>

                    <a name="legal_pp" class="terms-item-link"></a>
                    <h2>Privacy Policy</h2>

                    <h3>1. About Your Privacy and This Privacy Policy</h3>

                    <p>Your privacy is critical to us. We constantly put much thought, effort, tools, resources, and
                        procedures in place to protect and safeguard your privacy. This document is our &quot;Privacy
                        Policy,&quot; and it contains details on issues related to your privacy when using our services.
                        This Privacy Policy applies to visitors to the public websites owned and operated by Company,
                        the
                        registered users of the Platform. It is intended to inform you of our policies, procedures, and
                        practices regarding the collection, use, and disclosure of any information that you provide
                        through
                        the Platform. The Privacy Policy is part of our Terms and Conditions. The terms in the Privacy
                        Policy (such as but not limited to &quot;we,&quot; &quot;our,&quot; &quot;us,&quot; &quot;Platform,&quot;
                        and &quot;Counselor Services&quot;) have the same meaning as in our Terms and Conditions
                        document.
                        When you use our Platform, you accept and agree to the Terms and Conditions and the Privacy
                        Policy.
                        If you disagree with being bound to the Privacy Policy, you should stop using the Platform
                        immediately. By accessing and using our Platform, as applicable, you affirm that you have read
                        the
                        Terms and Conditions and the Privacy Policy and that you understand, agree to, and acknowledge
                        all
                        the terms contained in both.</p>

                    <h3>2. Information Collection, Use, and Disclosure</h3>

                    <h3>Categories of Information Collected</h3>

                    <p>To let us operate the Platform effectively and to let you use the Platform, we may collect, use,
                        and
                        store the information described below. We also disclose certain information to third parties, as
                        described further below. The information we collect is received directly or indirectly from you
                        and
                        generated during your use of the Platform. We also collect information generated as you use our
                        services and information from third parties, like when you access our services through your
                        Facebook
                        login or your Google Login. The data we collect is not used for marketing or other purposes
                        except
                        as specified in this Privacy Policy.&nbsp;</p>

                    <p><b>Visitor Data:</b> Company collects, uses, and stores data regarding user visits to its website
                        and
                        use of the the Platform (&quot;Visitor Data&quot;), including the particular pages visited or
                        viewed
                        by the user, the amount of time the user spent on the website, website errors experienced by the
                        user, visits the &nbsp;&quot;FAQ&quot; page, and information about the browser or device used to
                        access the website, such as the user&#39;s device ID and IP address.</p>

                    <p><b>Onboarding Data:</b> In addition to the information provided by users through the Platform,
                        Company collects, uses, and stores specific additional data from users during the onboarding
                        process
                        (&quot;Onboarding Data&quot;). This data includes the pages viewed by the user and whether the
                        user
                        clicks the &quot;Get started&quot; link to begin the test.</p>

                    <p><b>Account Registration Data:</b> Company collects, uses, and stores certain information in
                        connection with the account registration process, such as whether users registered using their
                        Google profiles and whether a user verifies their reported email address or phone number (&quot;Account
                        Registration Data&#39;&#39;). Company also assigns each user who creates an &nbsp;account an
                        anonymized, sequentially-generated client ID.</p>

                    <p><b>Transaction Data:</b> Company collects, uses, and stores certain information regarding payment
                        for
                        its services by users and related transactions on its website, such as whether a user completed
                        payment for services, signed up for &nbsp;services using a trial offer, canceled or otherwise
                        ended
                        a trial, or completed a request to receive financial aid for &nbsp;services (&quot;Transaction
                        Data&quot;).
                    </p>

                    <p><b>Login Data:</b> Company collects, uses, and stores data regarding logins to Platform by
                        registered
                        users and activity conducted during that login, such as when a user logs in, the number of
                        messages
                        received or sent through Platform during that login, and whether a user has been assigned,
                        started,
                        or completed a counseling goal (&quot;Login Data&quot;). Login Data does not include the content
                        of
                        any messages sent or received by users or the content of any counseling goals.</p>

                    <p><b>Customer Data:</b> Company collects, uses, and stores specific data from users that have
                        signed up
                        for services, such as a user&#39;s self-reported name or nickname, age, email address, phone
                        number,
                        and emergency contact information (&quot;Customer Data&quot;).</p>

                    <p><b>Communications Data:</b> Company collects, uses, and stores communications between users and
                        specialists on the Platform and between users and Company&#39;s customer service team (&quot;Communications
                        Data&quot;). Protecting this information is crucial for us. Other than in the ways detailed in
                        this
                        Privacy Policy, we will never use or disclose any information unless you request or approve us.
                        Purposes for Which Information Is Used We may use the information we collect for one or more of
                        the
                        following purposes:</p>

                    <h3>Communication with you</h3>

                    <ul>
                        <li>To contact you or provide information, alerts, and suggestions related to the Platform.</li>
                        <li>To verify your identity.</li>
                        <li>To complete an activity you requested, such as register for the Platform or obtain more
                            information.
                        </li>
                        <li>To reach out to you, either ourselves or using the appropriate authorities, if we have a
                            good
                            reason to believe that you or any other person may be in danger or may be either the cause
                            or
                            the victim of a criminal act.
                        </li>
                    </ul>

                    <h3>Delivery of services to you</h3>

                    <ul>
                        <li>To create your account on our Platform and let you log in to your account and use the
                            Platform.
                        </li>
                        <li>To manage your account, provide customer support, and ensure you receive quality service.
                        </li>
                        <li>For billing and transaction processing purposes.</li>
                        <li>To provide, support, personalize, and develop our Platform.</li>
                    </ul>

                    <h3>Administration and improvement of services</h3>

                    <ul>
                        <li>To supervise, administer and monitor the Platform.</li>
                        <li>To measure and improve our services&#39; quality, effectiveness, and delivery.</li>
                    </ul>

                    <h3>Customization</h3>

                    <ul>
                        <li>Personalize the website experience and deliver content and product and service offerings
                            relevant to individual interests, including targeted offers and ads.
                        </li>
                    </ul>

                    <h3>Compliance with the law</h3>

                    <ul>
                        <li>Respond to law enforcement requests as required by applicable law, court order, or
                            governmental
                            regulations.
                        </li>
                        <li>To comply with applicable state and federal laws, including but not limited to laws related
                            to
                            protecting client and public health and safety.
                        </li>
                        <li>To allow therapists to comply with their jurisdictions&#39; licensure, legal, and quality
                            requirements.
                        </li>
                    </ul>

                    <h3>Other uses with consent</h3>

                    <ul>
                        <li>Any other purpose with your consent.</li>
                    </ul>

                    <h3>Purposes for Which Information Is Disclosed to Third Parties</h3>

                    <p>Information about you may be disclosed to third parties for one or more of the following
                        purposes:</p>

                    <p><strong>For business purposes:</strong> We may share your information with vendors and service
                        providers, including our data hosting and storage partners, analytics and vendors providing
                        technology services and support, payment processing, and data security. We also may share
                        information with professional advisers, such as auditors, law firms, and accounting firms.</p>

                    <p>With your direction or consent: We may share your information with third parties if you request
                        or
                        direct us.</p>

                    <p>With affiliates within our corporate group: We may share your information with any subsidiaries
                        or
                        parent companies within our corporate group.</p>

                    <p><strong>For advertising:</strong> If you are opt-in to the use of targeting cookies and web
                        beacons,
                        information regarding your activity on our websites, excluding activity when you are logged in
                        and
                        have started therapy, may be disclosed to our advertising partners to optimize marketing. We do
                        not
                        share with any advertising platform private information like member names, email addresses,
                        phone
                        numbers, diagnosis, session data, journal entries, messages, worksheets, or any other type of
                        communication you have with your therapist if you want to opt-out of these cookies and web
                        beacons.&nbsp;
                    </p>

                    <p><b>Compliance with law:</b> We may share your information with a court, a regulatory entity, law
                        enforcement personnel, or under a subpoena to comply with applicable law or any obligations
                        thereunder.</p>

                    <p><strong>In the context of a transaction:</strong> We may share your information in connection
                        with an
                        asset sale, merger, bankruptcy, or other business transaction.</p>

                    <p>For other business reasons: We may share your information to enforce any applicable Terms and
                        Conditions and Terms and Conditions and to ensure the safety and security of the Platform and
                        our
                        users. Note that if you make any information publicly available on the Platform, anyone may see
                        and
                        use such information.</p>

                    <h3>3. Opting-out of Marketing Communication</h3>

                    <p>You can opt out of receiving email marketing by using the unsubscribe link in our marketing email
                        communications.</p>

                    <a name="cookies" class=""></a>
                    <h3>4. Cookies and Web Beacons</h3>

                    <p>Like many websites, we use &quot;cookies&quot; and &quot;web beacons&quot; (also known as pixels)
                        to
                        collect information. A &quot;cookie&quot; is a small data file transferred to your computer&#39;s
                        hard disk for record-keeping purposes. We collect cookies necessary for the Platform to
                        function,
                        cookies that enhance the Platform&#39;s performance, and cookies used for third-party tracking.
                        A
                        &quot;web beacon&quot; is a small and sometimes invisible image or embedded code placed on a Web
                        page or email that can report your visit or use to a third party. Web beacons are typically used
                        by
                        third parties to monitor the activity of users at a website for web analytics, advertising
                        optimization, or page tagging. Additional information regarding web beacons is available on
                        Wikipedia. You can change your browser&#39;s settings to stop accepting cookies and web beacons
                        or
                        prompt you before accepting a cookie or web beacon. Use of Cookies, Web Beacons, and Similar
                        Technology for analytics We may use third-party cookies or web beacons for web analytics,
                        attribution, and error management. Our Platform may use vendor services that use cookies, web
                        beacons, and similar technology to collect and store anonymous information about you, including
                        when
                        you pay for services, load a page, indicate that you heard about us on television, sign up for
                        services, enter your payment information (but the payment details are not disclosed), start the
                        intake questionnaire, and your response as to the referral source to the Platform. Our Platform
                        also
                        uses analytics vendors to collect information (for example, Visitor Data and Onboarding Data)
                        about
                        user actions on our websites for analytics and analysis of specific Platform usage. Use of
                        Cookies,
                        Web Beacons, and Similar Technology for Advertising Networks If you are opt-in to targeting
                        cookies
                        and web beacons, you and others may see certain ads for our services or the Platform on other
                        websites because we participate in ad networks. Ad networks allow us to target our messaging to
                        users through demographic, interest-based, and contextual means. Over time, these networks track
                        individuals&#39; online activities by collecting information through automated means, including
                        cookies, web server logs, and web beacons. The networks use this information to show
                        advertisements
                        that may be tailored to an individual&#39;s interests. Our ad networks may collect information
                        about
                        your visits to websites that participate in the relevant ad networks, such as the pages or
                        advertisements you view and the actions you take on the websites. This data collection takes
                        place
                        both on our websites and third-party websites participating in the ad networks. This process
                        also
                        helps us track the effectiveness of our marketing efforts and assists other websites and
                        advertising
                        partners in finding you or people like you on different platforms, including social media
                        websites.</p>

                    <h3>5. Social and General Information Tools</h3>

                    <p>We use several publicly-available tools and information exchange resources, such as (but not
                        limited
                        to) a blog and Facebook (?). Any information you provide or share while using Social and General
                        Information Tools may be read, accessed, and collected by that Site and users of that Site
                        according
                        to their Privacy Policy.</p>

                    <h3>6. Phishing</h3>

                    <p>Online identity theft and account hacking, including the practice currently known as &quot;phishing,&quot;
                        are of great concern. It would be best if you always were diligent when you are being asked for
                        your
                        account information, and you must always make sure you do that in our secure system. We will
                        never
                        request your login or credit card information in non-secure or unsolicited communication (email,
                        phone, or otherwise.</p>

                    <h3>7. Security of Information</h3>

                    <p>We take commercially reasonable steps to protect the integrity and confidentiality of personally
                        identifiable health information that you may share with us. Please be aware that no security
                        measures are perfect or impenetrable, and we cannot guarantee the absolute security of your
                        information. We will do our part to protect your information, but you must also protect your
                        data.
                        In addition, we do not control the actions of anyone with whom you or any other Platform user
                        may
                        choose to share information. As such, you should be cautious about the access you provide to
                        others
                        when using Platform and the data you choose to share when using Platform.</p>

                    <h3>8. Service Providers</h3>

                    <p>We may employ third-party companies and individuals to facilitate our Platform, perform specific
                        tasks which are related to the Platform, or provide audit, legal, operational, or other services
                        for
                        us. These tasks include but are not limited to customer service, technical maintenance,
                        monitoring,
                        email management and communication, database management, billing and payment processing,
                        reporting,
                        and analytics. We will share with them only the minimum necessary information to perform their
                        task
                        for us and only after entering into an appropriate confidentiality agreement.</p>

                    <p>We may provide, or third parties may provide, links to other third-party websites, services, or
                        resources beyond our control. We make no representations or endorsements regarding the quality,
                        suitability, functionality, or legality of any third-party content to which links may be
                        provided.
                        You hereby waive any claim you might have against us for such services. COMPANY IS NOT
                        RESPONSIBLE
                        FOR THE CONTENT ON THE INTERNET OR WEB PAGES LOCATED OUTSIDE THE PLATFORM.</p>

                    <p>Your business dealings with third parties found on or through the Platform, including payment,
                        and
                        any other terms, conditions, warranties, or representations associated with such dealings, are
                        solely between you and such third-party. You agree that we are not responsible or liable for any
                        loss or damage incurred from such transactions, the presence of such a third party, or links to
                        third-party websites or resources on the Platform.</p>

                    <h3>9. Compliance with Laws and Law Enforcement</h3>

                    <p>We cooperate with government and law enforcement officials to enforce and comply with the law. We
                        may
                        disclose information necessary or appropriate to protect the safety of the public or any person,
                        to
                        respond to claims and legal processes (including but not limited to subpoenas), and to prevent
                        or
                        stop an activity that may be illegal or dangerous. You should also be aware that our specialists
                        may
                        be obliged to disclose information to law enforcement or other authorities to conform to their
                        professional and legal responsibilities. Specifically, and without limitation, you should be
                        aware
                        that the law requires mental health professionals to disclose information and/or take action in
                        the
                        following cases:</p>

                    <ol start="1" style="margin-top:0cm" type="1">
                        <li>Reported or suspected abuse of a child or vulnerable adult.</li>
                        <li>Serious suicidal potential.</li>
                        <li>Threatened harm to another person.</li>
                        <li>Court-ordered presentation of treatment.</li>
                    </ol>

                    <h3>10. Changes to the Privacy Policy</h3>

                    <p>We may update this privacy statement at our sole discretion. The date of the last revision of
                        this
                        policy appears at the end of this page. We encourage you to periodically review this page for
                        the
                        latest information on our Privacy Policy and practices. Regardless of changes to our Privacy
                        Policy,
                        we will never use the information you submit under our current privacy notice in a new way
                        without
                        first notifying you and giving you the option to stop using the Platform.</p>

                    <h3>11. Contacting us</h3>

                    <p>If you have any questions or concerns about this Privacy Policy or our privacy-related practices,
                        please get in touch with us at questions@anima.help. If you want to cooperate with us, don&#39;t
                        hesitate to contact us at cooperation@anima.help.</p>

                    <a name="legal_npp" class="terms-item-link"></a>
                    <h2>Notice of privacy practices</h2>

                    <p>We may collect the following kinds of information when you use the Services:</p>

                    <p>Information you provide directly to us. For certain activities, such as when you register, use
                        our
                        telemedicine services, subscribe to our alerts, or contact us directly, we may collect some or
                        all
                        of the following types of information:</p>

                    <ul>
                        <li>Contact information, such as your full name, email address, and mobile phone number;</li>
                        <li>Username and password;</li>
                        <li>Payment information, such as your credit card number, expiration date, and credit card
                            security
                            code;
                        </li>
                        <li>Personal health information;</li>
                        <li>Any other information you provide to us.</li>
                    </ul>

                    <p>We may combine such information with information we already have about you.</p>

                    <p>Information we collect automatically. We may collect certain information automatically when you
                        use
                        our Services, such as your Internet protocol (IP) address, device, and advertising identifiers,
                        browser type, operating system, Internet service provider, pages that you visit before and after
                        using the Services, the date and time of your visit, information about the links you click and
                        pages
                        you view within the Services, and other standard server log information. We may also collect
                        location information when you use our Services, such as your computer&#39;s IP address, your
                        mobile
                        device&#39;s GPS signal, or information about nearby WiFi access points and cell towers.</p>

                    <p>We may use cookies, pixel tags, Local Shared Objects, and similar technologies to collect this
                        information automatically. By using the Services, you consent to our use of cookies and similar
                        technologies.</p>

                    <p>We may also collect technical data to address and fix technical problems and improve our
                        Services,
                        including the memory state of your device when a system or app crash occurs while using our
                        Services. Your device or browser settings may permit you to control the collection of this
                        technical
                        data. This data may include parts of a document you used or the contents of your communications
                        when
                        a problem occurred. By using the Services, you consent to collect this technical data.</p>

                    <p>Information we obtain from your health care providers and other sources.</p>

                    <h3>Use of information</h3>

                    <p>We generally use the information we collect online to:</p>

                    <ul>
                        <li>Provide and improve the Services;</li>
                        <li>Contact you;</li>
                        <li>Fulfill your requests for products, services, and information;</li>
                        <li>Send you information about additional services or general wellness from us or on behalf of
                            our
                            affiliates and trusted third-party partners;
                        </li>
                        <li>Analyze the use of the Services and user data to understand and improve the Services;</li>
                        <li>Customize the content you see when you use the Services;</li>
                        <li>Conduct research using your information, which may be subject to your separate written
                            authorization;
                        </li>
                        <li>Prevent potentially prohibited or illegal activities and otherwise by our Terms of Use</li>
                        <li>For any other purposes disclosed when we collect your information or under your consent.
                        </li>
                    </ul>

                    <h3>Sharing of information</h3>

                    <p>We are committed to maintaining your trust and want you to understand when and with whom we may
                        share
                        the information we collect.</p>

                    <ul>
                        <li>Healthcare providers, insurance companies, and other healthcare-related entities. We may
                            share
                            your information with other service providers, agencies, companies, organizations.
                        </li>
                        <li>Authorized third-party vendors and service providers. We may share your information with
                            third-party vendors and service providers that help us with specialized services, including
                            billing, payment processing, customer service, email deployment, business analytics,
                            marketing
                            (including but not limited to advertising, attribution, mobile marketing, optimization, and
                            retargeting), performance monitoring, hosting, and data processing. These third-party
                            vendors
                            and service providers may not use your information for purposes other than those related to
                            the
                            services they are providing to us.
                        </li>
                        <li>Research partners. We may share your information with our research partners to conduct
                            health-related research; such sharing may be subject to your written authorization.
                        </li>
                        <li>Corporate affiliates. We may share your information with our corporate affiliates subject to
                            this policy.
                        </li>
                        <li>Business transfers. We may share your information in connection with a substantial corporate
                            transaction, such as the sale of a website, a merger, consolidation, asset sale, or in the
                            unlikely event of bankruptcy.
                        </li>
                        <li>Legal purposes. We may disclose information to respond to subpoenas, court orders, legal
                            processes, law enforcement requests, legal claims, or government inquiries, and to protect
                            and
                            defend the rights, interests, health, safety, and security of our users, or the public.
                            Suppose
                            we are legally compelled to disclose information about you to a third party. In that case,
                            we
                            will attempt to notify you by sending an email to the email address in our records unless
                            doing
                            so would violate the law or you have not provided your email address to us.
                        </li>
                        <li>With your consent or at your direction. We may share information for any other purposes
                            disclosed to you at the time we collect the information or under your consent or direction.
                        </li>
                    </ul>

                    <p>Outside of the use cases specified above, we will not provide your information to third parties.
                        However, third-party access services, such as Facebook or Google, through the Services to login
                        to
                        the Services or to share information about your experience on the Services with others. These
                        third-party services may be able to collect information about you, including information about
                        your
                        activity on the Site. They may notify your connections on the third-party services about your
                        site
                        use under their privacy policies.</p>

                    <p>If you engage in public activities on the Site or third-party sites that we link to, you should
                        be
                        aware that any information you share there can be read, collected, or used by other users of
                        these
                        areas. It would be best to use caution when disclosing personal information while participating
                        on
                        these sites. We are not responsible for the data you choose to submit in these public areas.</p>

                    <h3>Security</h3>

                    <p>We use reasonable measures to help protect information from loss, theft, misuse, unauthorized
                        access,
                        disclosure, alteration, and destruction. You should understand that no data storage system or
                        data
                        transmission over the Internet or any other public network can be guaranteed 100 percent secure.
                        Please note that information collected by third parties may not have the same security
                        protections
                        as information you submit to us, and we are not responsible for protecting the security of such
                        information.</p>

                    <a name="legal_nnd" class="terms-item-link"></a>
                    <h2>Notice of Nondiscrimination</h2>

                    <p>Company does not discriminate and does not permit discrimination, including, without limitation,
                        bullying, abuse, or harassment, based on actual or perceived race, color, religion, national
                        origin,
                        ancestry, age, gender, physical or mental disability, sexual orientation, gender identity or
                        expression or HIV status, or based on association with another person on account of that person&#39;s
                        actual or perceived race, color, religion, national origin, ancestry, age, gender, physical or
                        mental disability, sexual orientation, gender identity or expression or HIV status.</p>

                    <p>Effective date August 21, 2022</p>

                </div>

            </div>

        </div>
    </section>
</ng-container>

<ng-container *ngIf="lang.currentLang === 'uk'">
    <section class="terms-item" lang="uk">
        <div class="container">
            <div class="row">
                <div class="col col-md-2"></div>
                <div class="col-12 col-md-10">
                    <a name="legal_tad" class="terms-item-link"></a>

                    <div>
                        <div class="mb-5 pb-5 d-flex align-items-end">
                            <h2 class="mb-0">Договір</h2>
                            <p class="pl-2">публічної оферти про надання послуг</p>
                        </div>

                        <p>
                            <b>Фізична особа-підприємець Гавриш Роман Орестович, ЄДРПОУ 2955307855</b> (надалі -
                            «Виконавець»), з
                            однієї сторони, пропонує необмеженому колу фізичних осіб (надалі - «Замовник»), з іншої
                            Сторони (надалі разом - «Сторони») – акцептувати цю Публічну оферту (<i>укласти договір про
                            надання
                            послуг</i>).
                        </p>


                        <h3>Розділ 1. Терміни</h3>
                        <p>
                            1.1. Публічна оферта – пропозиція Виконавця (викладена на веб-сайті Виконавця), адресована
                            необмеженому колу фізичних осіб відповідно до статті 641 Цивільного кодексу України укласти
                            Договір про надання послуг на визначених умовах Договору. Оферта є публічною і, згідно ст. ст.
                            633, 641 ЦК України, її умови однакові для всіх Замовників.
                        </p>
                        <p>
                            1.2. Договір – правочин, складений у формі договору приєднання відповідно до ст. 634 Цивільного
                            кодексу України, умови якого встановлені Виконавцем, і який може бути укладено лише шляхом
                            приєднання Замовника до запропонованого Договору в цілому.
                        </p>
                        <p>
                            1.3. Cайт Виконавця (Платформа) – веб-сторінка в мережі Інтернет, за адресою <a
                                href="https://ua.anima.help/" target="_blank">https://ua.anima.help/</a>, яка є основним
                            джерелом інформування Замовника та може бути використана Замовником для замовлення послуг
                            Виконавця.
                        </p>
                        <p>
                            1.4. Послуги – сукупність інформаційних матеріалів та AI-консультацій, що носять
                            інформаційно-роз'яснювальний характер, надаються під час сесій тестування, реалізуються шляхом
                            надання доступу до онлайн-сервісу Anima, та використовуються для надання інформації про стан
                            особи, яка використовує платформу. Повний перелік послуг, їх вартість та детальна інформація
                            щодо них викладені на Сайті Виконавця, за адресою <a href="https://ua.anima.help/#plans"
                                                                                 target="_blank">https://ua.anima.help/</a>.
                        </p>
                        <p>
                            1.5. Замовник – будь-яка дієздатна фізична особа, яка Акцептувала Публічну оферту Виконавця,
                            викладену у Договорі.
                        </p>
                        <p>
                            1.6. Акцепт – повне, безумовне та беззастережне прийняття Замовником умов визначених Офертою
                            згідно із частиною 2 статті 642 Цивільного кодексу України, після чого Договір автоматично
                            вважається укладеним. Акцепт може бути здійснений шляхом перерахування грошових коштів на
                            банківський рахунок Виконавця або сервісу платіжної системи за посиланням Виконавця, в якості
                            повної оплати за надання послуг за цим Договором.
                        </p>

                        <h3>
                            Розділ 2. Предмет договору і загальні умови
                        </h3>
                        <p>
                            2.1. Виконавець зобов’язується надати Замовнику передбачені договором Послуги, в строки та на
                            умовах, визначені Договором, а Замовник зобов'язується своєчасно прийняти та оплатити їх.
                        </p>
                        <p>
                            2.2. Послуги, що надає Виконавець в межах цього договору не є медичними, а надана Замовнику
                            інформація не замінює професійну медичну консультацію, діагностику чи лікування.
                        </p>
                        <p>
                            2.3. Замовник надає згоду Виконавцю на використання та обробку його персональних даних в рамках
                            Закону України «Про захист персональних даних».
                        </p>

                        <h3>
                            Розділ 3. Порядок укладення Договору
                        </h3>

                        <p>
                            3.1. Укладання Договору проводиться шляхом повного і беззастережного прийняття (акцептування)
                            Замовником умов Договору. Замовник здійснює акцепт Договору шляхом натискання кнопок “Купити”
                            та “Передплатити” на сторінці сайту <a href="https://ua.anima.help/#plans">https://ua.anima.help/</a>,
                            та оплати обраної Замовником Послуги.
                        </p>
                        <p>
                            3.2. Замовник підтверджує, що до укладення Договору він був повністю та належним чином
                            ознайомлений з усіма його положеннями та прийняв їх.
                        </p>
                        <p>
                            3.3. Договір, за умови дотримання порядку його акцептування, вважається укладеним в письмовій
                            формі, вступає в силу з моменту акцепту і діє протягом усього терміну отримання Послуг, або до
                            моменту його розірвання на підставах, визначених умовами Договору та/або нормами чинного
                            законодавства України.
                        </p>

                        <h3>
                            Розділ 4. Права та обов`язки сторін
                        </h3>

                        <p>
                            4.1. Виконавець зобов’язаний:
                        </p>
                        <ul>
                            <li> 4.1.1. Надати Замовнику своєчасно, якісно та в повному обсязі Послуги відповідно до умов
                                Договору, а також усю необхідну інформацію, пов’язану з наданням таких Послуг.
                            </li>
                            <li>4.1.2. Повідомляти Замовника про настання будь-яких обставин, що унеможливлюють надання
                                Послуг.
                            </li>

                        </ul>
                        <p>
                            4.2. Виконавець має право:
                        </p>

                        <ul>
                            <li>
                                4.2.1. На своєчасну та повну оплату наданих Послуг відповідно до умов Договору.
                            </li>
                            <li>
                                4.2.2. Змінювати вартість та (або) порядок надання Послуг, повідомивши Замовника про такі
                                зміни
                                шляхом розміщення інформації на Сайті.
                            </li>
                            <li>
                                4.2.3. Припинити в односторонньому порядку надання послуг Замовнику (зокрема, але не
                                виключно) у
                                разі наявності заборгованості Замовника перед Виконавцем за надані послуги.
                            </li>
                            <li>
                                4.2.4. Змінити, призупинити, або припинити роботу Платформи, будь-якої частини Платформи або
                                використання Платформи, як для всіх клієнтів, так і для окремого Замовника у випадках,
                                передбачених Договором.
                            </li>
                            <li>
                                4.2.5. Надсилати Замовнику сповіщення або інші повідомлення щодо договору або будь-якого
                                аспекту
                                Платформи електронною поштою на зареєстровану адресу електронної пошти Замовника, звичайною
                                поштою або шляхом розміщення в Інтернеті.
                            </li>
                        </ul>
                        <p>
                            4.3. Замовник зобов’язаний:
                        </p>
                        <ul>
                            <li>
                                4.3.1. Прийняти та оплатити надані Виконавцем послуги у заздалегідь обумовлені Виконавцем
                                строки.
                            </li>
                            <li>
                                4.3.2. Надавати усю необхідну інформацію про себе Виконавцю, що необхідна для надання
                                останнім
                                Послуг за договором.
                            </li>
                            <li>
                                4.3.3. Замовник підтверджує та погоджується, що вся інформація, яку він надав на Платформі
                                або
                                через неї, а також інформація, яку він надасть на Платформі чи через неї в майбутньому, є
                                точною, правдивою, актуальною та повною. Замовник погоджується, що протягом дії цього
                                Договору
                                він буде підтримувати та оновлювати цю інформацію, щоб вона залишалася точною, актуальною та
                                повною.
                            </li>
                            <li>
                                4.3.4. Замовник погоджується, підтверджує та визнає, що несе відповідальність за збереження
                                конфіденційності свого пароля та будь-якої іншої інформації безпеки, пов’язаної з його
                                обліковим
                                записом.
                            </li>
                            <li>
                                4.3.5. Замовник погоджується негайно повідомити Виконавця про будь-яке несанкціоноване
                                використання доступу до його облікового запису.
                            </li>
                            <li>
                                4.3.6. Замовник погоджується, підтверджує та визнає, що Виконавець не несе відповідальності
                                за
                                будь-які втрати чи збитки, заподіяні кимось іншим, хто користується обліковим записом
                                Замовника,
                                з його згодою та/або без відома.
                            </li>
                            <li>
                                4.3.7. Замовник визнає та погоджується з тим, що Виконавець буде вважати його відповідальним
                                за
                                будь-які збитки або втрати, спричинені використанням доступу до облікового запису Замовника
                                будь-якою особою, уповноваженою ним чи ні, і погоджується відшкодувати Виконавцю будь-яку
                                таку
                                шкоду або втрату.
                            </li>
                            <li>
                                4.3.8. Замовник погоджується і зобов’язується не використовувати обліковий запис або доступ
                                до
                                облікового запису іншої особи з будь-якої причини.
                            </li>
                            <li>
                                4.3.9. Замовник погоджується та зобов’язується не втручатися чи порушувати роботу будь-якої
                                з
                                систем, служб, серверів, мереж чи інфраструктури Виконавця або Платформи, а також не
                                намагатися
                                втручатися чи порушувати їх роботу, включаючи отримання несанкціонованого доступу до них.
                            </li>
                        </ul>
                        <p>
                            4.4. Замовник має право:
                        </p>
                        <ul>
                            <li>
                                4.4.1. Вимагати від Виконавця своєчасного та якісного надання послуг за цим Договором.
                            </li>
                        </ul>


                        <h3>
                            Розділ 5. Оплата та порядок отримання Послуг
                        </h3>
                        <p>
                            5.1. Оплата послуг Виконавця здійснюється на умовах повної попередньої оплати у порядку,
                            передбаченому пунктом 3.1. Договору. Ціна Послуг зазначається на Сайті Виконавця за посиланням
                            <a href="https://ua.anima.help/#plans" target="_blank">https://ua.anima.help/</a> і
                            залежить від виду послуги та її тривалості.
                        </p>
                        <p>
                            5.2. У разі, якщо оплата здійснюється за допомогою платіжних систем і сервісів, Замовник
                            перенаправляється на сайт платіжного сервісу. В цьому випадку оплата додатково регулюється
                            правилами платіжного сервісу, банку (в тому числі банку емітента картки Замовника) та інших
                            учасників платежів. Виконавець не здійснює обробку операцій по банківським карткам. У разі
                            помилок або відмов в оплаті Замовник має звернутися до банка-емітента картки або до представника
                            платіжної системи, через яку здійснювалась оплата.
                        </p>
                        <p>
                            5.3. Замовник самостійно несе відповідальність за надання помилкових даних, що спричинило
                            неможливість належного виконання Виконавцем своїх зобов'язань перед Замовником.
                        </p>
                        <p>
                            5.4. Ціна Послуги не містить в собі комісію і додаткові збори банків та платіжних систем.
                            Замовник самостійно і своїм коштом сплачує такі збори. Розмір комісії або додаткового збору
                            повідомляє відповідний банк та платіжна система.
                        </p>
                        <p>
                            5.5. Сторони погоджуються, що невикористання інформації, отриманої під час споживання Послуги з
                            боку Замовника не є підставою для відмови від Договору та підставою для повернення коштів за
                            надану частину Послуг. З
                        </p>
                        <p>
                            5.6. Замовник визнає, що оскільки відповідні Послуги являють собою сесії тестування та
                            інформаційні матеріали, їх якість та повнота презюмується та приймається Замовником без
                            заперечень. Інформація, до якої можна отримати доступ в процесі споживання Послуги, може не
                            охоплювати всі психічні ресурси, захворювання та/або стани, а також їх лікування, а також
                            надається «Як є» і без гарантій, явних чи неявних, включаючи, але не обмежуючись, будь-якими
                            непрямими гарантіями придатності для певної мети.
                        </p>
                        <p>
                            5.7. Після оплати послуг Виконавця Замовник отримає доступ до переліку сервісів, у формі сесій
                            тестування та інформаційних матеріалів у формі рекомендацій та облікового запису.
                        </p>
                        <p>
                            5.8. Доступ до таких сервісів та матеріалів може бути обмежений періодом, зазначеним на сайті
                            Виконавця та залежить від обраного виду Послуги.
                        </p>
                        <p>
                            5.9. Повернення коштів можливе до початку споживання Послуги. Замовник до початку споживання
                            Послуги має право відмовитися від її отримання. В такому випадку сплачені Замовником, будуть
                            повернені. Для реалізаціı̈ права на повернення коштів Замовник має направити відповідне
                            повідомлення Виконавцю на зазначену електронну адресу
                            <a href="mailto:support@anima.help">support@anima.help</a>.
                        </p>

                        <h3>
                            Розділ 6. Відповідальність сторін
                        </h3>
                        <p>
                            6.1. Сторони несуть відповідальність за невиконання чи неналежне виконання зобов'язань за цим
                            Договором відповідно до чинного законодавства України, з урахуванням особливостей,
                            встановлених Договором.
                        </p>
                        <p>
                            6.2. Сторона не несе відповідальності за порушення Договору, якщо воно сталося не з її вини
                            (умислу чи необережності). Сторона вважається невинуватою і не несе відповідальності за
                            порушення Договору, якщо вона доведе, що вжила всіх залежних від неї заходів щодо належного
                            виконання цього Договору.
                        </p>
                        <p>
                            6.3. Сторони звільняються від відповідальності за невиконання або неналежне виконання
                            зобов’язань за цим Договором у разі виникнення обставин непереборної сили, які не існували під
                            час укладання Договору та виникли поза волею Сторін. Такими обставинами є: стихійні лиха,
                            екстремальні погодні умови, пожежі, епідемії, будь-які військові дії, катастрофи, аварії,
                            страйки, забороняючі акти органів держаної влади тощо.
                        </p>
                        <h3>
                            Розділ 7. Інтелектуальна власність
                        </h3>
                        <p>
                            7.1. Виконавець володіє винятковими правами на об’єкти права інтелектуальної власності, доступ
                            до яких матиме Замовник в рамках виконання даного Договору. Будь-яке отримання доступу
                            Замовником за цим Договором до сервісів Виконавця, не призводить до передачі Замовнику будь-яких
                            прав інтелектуальної власності на них.
                        </p>
                        <p>
                            7.2. Оплативши Послуги за цим Договором Замовник:
                        </p>
                        <ul>
                            <li>
                                1) отримує тимчасовий доступ до матеріалів, авторські та суміжні права на які належать
                                Виконавцю;
                            </li>
                            <li>
                                2) впродовж строку, погодженого з Виконавцем Замовник має право користуватися сервісами в
                                межах оплаченої Послуги у власних некомерційних цілях. Матеріали можуть бути використані
                                наступними способами: ознайомлення, перегляд, прочитання, відтворення виключно в особистих
                                цілях. Комерційне використання таких матеріалів, їх копіювання, переробка, повне або
                                часткове використання, публічне відтворення або розповсюдження матеріалів без письмового
                                дозволу Виконавця забороняється.
                            </li>
                        </ul>
                        <p>
                            7.3. У разі виявлення будь-яких інших порушень прав інтелектуальної власності Виконавець має
                            право вимагати від Замовника повного відшкодування збитків, заподіяних таким порушенням.
                        </p>
                        <p>
                            7.4. Будь-яка частина Платформи не може бути скопійована, відтворена, повторно опублікована,
                            завантажена, розміщена, відображена, передана або розповсюджена.
                        </p>

                        <h3>
                            Розділ 8. Інші умови
                        </h3>

                        <p>
                            8.1. Порядок врегулювання спорів та застосовне право.
                        </p>
                        <ul>
                            <li>
                                8.1.1. Всі суперечки та спори, що можуть виникнути в процесі надання послуг Виконавцем, у
                                зв’язку з прийняттям, виконанням та/або порушенням положень цього Договору та всіх додатків
                                до нього, врегульовуються шляхом переговорів Сторін.
                            </li>
                            <li>
                                8.1.2. В разі недосягнення згоди шляхом переговорів, Замовник залишає за собою право на
                                пред’явлення претензій, які обов’язково повинні бути розглянуті Виконавцем в розумні
                                строки, з метою врегулювання суперечок та спорів в досудовому порядку.
                            </li>
                            <li>
                                8.1.3. В разі недосягнення згоди між Сторонами, шляхом переговорів та неможливості
                                врегулювання в досудовому порядку, всі спори та суперечки вирішуються в судовому порядку за
                                місцезнаходженням Виконавця.
                            </li>
                            <li>
                                8.1.4. До відносин сторін, що випливають з прийняття та виконання даного Договору ,
                                застосовуються чинні норми та положення законодавства України.
                            </li>
                        </ul>
                        <p>
                            8.2. Обмеження відповідальності Виконавця.
                        </p>
                        <ul>
                            <li>8.2.1. Сторони розуміють і визнають, що невідповідність результату надання тієї чи іншої
                                Послуги
                                результату, що очікував та бажав отримати Замовник при зверненні за наданням відповідної
                                Послуги,
                                саме по собі не є фактом неналежної якості наданої Послуги.
                            </li>
                        </ul>
                        <p>
                            8.3. Прикінцеві положення.
                        </p>
                        <ul>
                            <li>
                                8.3.1. Виконавець залишає за собою право в будь-який час в односторонньому порядку вносити
                                зміни до даного Договору.
                            </li>
                            <li>
                                8.3.2. Всі зміни до цього Договору публікуються на Сайті Виконавця.
                            </li>
                            <li>
                                8.3.3. Всі зміни до даного Договору набувають чинності з моменту їх публікації на Сайті
                                Виконавця.
                            </li>
                            <li>
                                8.3.4. Внесені зміни, що набрали чинності, розповсюджуються на всіх Замовників.
                            </li>
                            <li>
                                8.3.5. Замовники вважаються повідомленими про внесені до Договору зміни з моменту
                                опублікування цих змін на Сайті Виконавця.
                            </li>
                            <li>
                                8.3.6. Після розміщення дійсного Договору Публічної оферти на сайті Виконавця всі
                                попередні погодження, які вступають з ним в протиріччя, втрачають силу.
                            </li>
                            <li>
                                8.3.7. Контактні дані Виконавця: Київ 04050, Україна. Миколи Пимоненка вул., 13ж, 3-й
                                поверх, <a href="mailto:support@anima.help">support@anima.help</a> та <a
                                    href="mailto:cooperation@anima.help">cooperation@anima.help</a>.
                            </li>
                        </ul>
                        <p class="text-muted mt-4">Редакція станом на 18.07.2024</p>

                    </div>

                    <!--                to-->
                    <a name="legal_pp" class="terms-item-link"></a>
                    <h2>Політика конфіденційності </h2>

                    <h3>1. Про вашу конфіденційність і цю Політику конфіденційності</h3>

                    <p>Ваша конфіденційність надзвичайно важлива для нас. Ми постійно докладаємо багато зусиль,
                        інструментів, ресурсів і процедур, щоб захистити вашу конфіденційність. Цей документ є нашою
                        «Політикою конфіденційності», і він містить детальну інформацію про проблеми, пов’язані з вашою
                        конфіденційністю під час використання наших послуг. Ця Політика конфіденційності поширюється на
                        відвідувачів загальнодоступних веб-сайтів, якими володіє та керує Anima, зареєстрованих користувачів
                        веб-додатку Anima (разом із веб-сайтами, «Платформа»). Він призначений для інформування вас про нашу
                        політику, процедури та практику щодо збору, використання та розкриття будь-якої інформації, яку ви
                        надаєте через Платформу. Якщо ви є нинішнім або колишнім претендентом на роботу Anima, працівником,
                        власником, директором, посадовою особою чи підрядником, зв’яжіться з нами за адресою
                        questions@anima.help. Ваші права відповідно до законів про конфіденційність, які діють у вашій
                        юрисдикції, представлені в додатку до цієї політики. Якщо ви не бачите цього додатку нижче,
                        зв’яжіться з нами за адресою questions@anima.help, щоб отримати додаткову інформацію з описом ваших
                        прав відповідно до цих законів. Політика конфіденційності є частиною наших Умов використання.
                        Терміни в Політиці конфіденційності (такі як, але не виключно, «ми», «наш», «нас», «Платформа» та
                        «Послуги консультантів») мають те саме значення, що й у нашому документі «Загальні положення та
                        умови». Коли ви користуєтеся нашою платформою, ви приймаєте та погоджуєтеся як з Умовами
                        використання, так і з Політикою конфіденційності. Якщо ви не згодні дотримуватися Політики
                        конфіденційності, вам слід негайно припинити використання Платформи. Отримавши доступ і
                        використовуючи нашу Платформу, ви підтверджуєте, що прочитали Умови використання та Політику
                        конфіденційності та розумієте, погоджуєтесь і визнати всі умови, що містяться в них обох.</p>

                    <h3>2. Збір, використання та розкриття інформації.</h3>

                    <h3>Категорії зібраної інформації. </h3>

                    <p>Щоб дозволити нам ефективно керувати Платформою та дозволити вам користуватися Платформою, ми можемо
                        збирати, використовувати та зберігати інформацію, описану нижче. Ми також розкриваємо певну
                        інформацію третім сторонам, як описано нижче. Інформація, яку ми збираємо, отримується прямо чи
                        опосередковано від вас і генерується під час використання вами Платформи. Дані, які ми збираємо, не
                        використовуються для маркетингових чи будь-яких інших цілей, за винятком випадків, визначених цією
                        Політикою конфіденційності. </p>

                    <p><b>Дані відвідувачів:</b> Anima збирає, використовує та зберігає дані щодо відвідувань користувачами
                        її веб-сайту та використання програми Anima («Дані відвідувачів»), включаючи конкретні сторінки, які
                        відвідав або переглянув користувач, кількість часу, який користувач витратив на веб-сайт або
                        додаток, помилки веб-сайту, з якими стикається користувач, відвідування сторінки «FAQ» Anima, а
                        також інформацію про браузер або пристрій, який використовується для доступу до веб-сайту та
                        програми, наприклад, ідентифікатор мобільного пристрою користувача та IP-адресу.</p>

                    <p><b>Дані реєстрації: </b>на додаток до відповідей на анкету, наданих користувачами під час початкової
                        реєстрації, Anima збирає, використовує та зберігає певні додаткові дані від користувачів під час
                        процесу реєстрації («Дані реєстрації»). Ці дані включають сторінки, які переглядає користувач, чи
                        натискає користувач посилання «Почати», щоб розпочати тест. </p>

                    <p><b>Реєстраційні дані облікового запису:</b> Anima збирає, використовує та зберігає певну інформацію у
                        зв’язку з процесом реєстрації облікового запису, наприклад, чи зареєстровані користувачі за
                        допомогою профілем Facebook або Google, а також те, чи підтверджує користувач свою адресу
                        електронної пошти чи номер телефону («Реєстраційні дані облікового запису»). Anima також призначає
                        кожному користувачеві, який створює обліковий запис Anima, анонімний, послідовно згенерований
                        ідентифікатор клієнта.</p>

                    <p><b>Дані транзакцій:</b> Anima збирає, використовує та зберігає певну інформацію щодо оплати своїх
                        послуг користувачами та пов’язаних транзакцій на своєму веб-сайті, наприклад, чи здійснив користувач
                        оплату послуг Animas, зареєструвався на послуги Anima за допомогою пробної пропозиції, скасував чи
                        іншим чином закінчив пробну версію або завершив запит на отримання фінансової допомоги для послуг
                        Anima («Дані транзакції»).
                    </p>

                    <p><b>Дані для входу:</b> Anima збирає, використовує та зберігає дані щодо входу на платформу Anima
                        зареєстрованими користувачами та активності під час цього входу, наприклад, коли користувач входить,
                        кількість повідомлень, отриманих або надісланих через веб-сайт або додаток Anima під час цього
                        входу, а також те, чи було призначено, розпочато чи виконано користувачем. Дані для входу не
                        включають вміст будь-яких повідомлень, надісланих або отриманих користувачами, або вміст будь-яких
                        цілей консультування.</p>

                    <p><b>Дані клієнта:</b> Anima збирає, використовує та зберігає певні дані від користувачів, які
                        зареєструвалися на послуги Anima, такі як ім’я або псевдонім, вік, адресу електронної пошти, номер
                        телефону та контактну інформацію для екстрених випадків («Дані клієнта»).</p>

                    <p><b>Комунікаційні дан:</b> Anima збирає, використовує та зберігає комунікаційні дані між користувачами
                        та фахівцями на Платформі, а також комунікації між користувачами та командою обслуговування клієнтів
                        Anima («Комунікаційні дані»). Захист цієї інформації важливий для нас. Окрім способів, описаних у
                        цій Політиці конфіденційності, ми ніколи не використовуватимемо та не розголошуватимемо жодної
                        інформації, якщо ви не попросите або не схвалите це.
                        Цілі, для яких використовується інформація: ми можемо використовувати зібрану інформацію для однієї
                        або кількох із наведених нижче цілей:
                    </p>

                    <h3>Спілкування з вами</h3>

                    <ul>
                        <li>Щоб зв’язатися з вами або надати вам інформацію, сповіщення та пропозиції, пов’язані з
                            Платформою.
                        </li>
                        <li>Щоб підтвердити вашу особу.</li>
                        <li>Для завершення дії, яку ви запитували, наприклад, реєстрації на Платформі або отримання
                            додаткової інформації.
                        </li>
                        <li>Щоб зв’язатися з вами, самостійно або за допомогою відповідних органів, якщо ми маємо вагомі
                            підстави вважати, що ви чи будь-яка інша особа можете опинитися в небезпеці або можете бути
                            причиною або жертвою злочинного діяння.
                        </li>
                    </ul>

                    <h3>Надання вам послуг</h3>

                    <ul>
                        <li>Щоб створити свій обліковий запис на нашій Платформі та дозволити вам увійти у свій обліковий
                            запис і використовувати Платформу.

                        </li>
                        <li>Щоб керувати вашим обліковим записом, надавати вам підтримку клієнтів і гарантувати, що ви
                            отримуєте якісне обслуговування.
                        </li>
                        <li>Для виставлення рахунків і обробки транзакцій.
                        </li>
                        <li>Для забезпечення, підтримки, персоналізації та розвитку нашої Платформи.</li>
                    </ul>

                    <h3>Адміністрування та вдосконалення послуг</h3>

                    <ul>
                        <li>Для нагляду, адміністрування та моніторингу Платформи.</li>
                        <li>Вимірювати та покращувати якість, ефективність і надання наших послуг.</li>
                    </ul>

                    <h3>Налаштування</h3>

                    <ul>
                        <li>Щоб персоналізувати досвід веб-сайту та надавати вміст, а також пропозиції продуктів і послуг,
                            що відповідають індивідуальним інтересам, включаючи цільові пропозиції та рекламу.
                        </li>
                    </ul>

                    <h3>Відповідність закону</h3>

                    <ul>
                        <li>Щоб відповідати на запити правоохоронних органів і відповідно до чинного законодавства, ухвали
                            суду чи державних постанов.
                        </li>
                        <li>Для дотримання відповідних державних і федеральних законів, включаючи, але не обмежуючись
                            законами, пов’язаними із захистом здоров’я та безпеки клієнтів і населення.
                        </li>
                        <li>Дозволити терапевтам відповідати ліцензійним, юридичним вимогам і вимогам щодо якості в їхніх
                            юрисдикціях.
                        </li>
                    </ul>

                    <h3>Інше використання за згодою</h3>

                    <ul>
                        <li>Будь-які інші цілі за вашою згодою.</li>
                    </ul>

                    <h3>Цілі, з якими інформація розкривається третім особам.</h3>

                    <p>Інформація про вас може бути розголошена третім сторонам з однією або декількома з наведених нижче
                        цілей:</p>

                    <p><strong>Для комерційних цілей:</strong> ми можемо надавати вашу інформацію постачальникам послуг,
                        включаючи наш хостинг даних і дані партнери зі зберігання, аналітикам, що надають технологічні
                        послуги та підтримку, обробку платежів і безпеку даних. Ми також можемо ділитися інформацією з
                        професійними радниками, такими як аудитори, юридичні та бухгалтерські компанії. За вашою вказівкою
                        чи згодою: ми можемо надати вашу інформацію третім сторонам, якщо ви попросите або дасте нам наказ
                        про це. З афілійованими особами в межах нашої корпоративної групи: ми можемо надати вашу інформацію
                        будь-яким дочірнім або материнським компаніям у нашій корпоративній групі.</p>


                    <p><strong>Для реклами:</strong>якщо ви погоджуєтеся на використання цільових файлів cookie та
                        веб-маяків, інформація про вашу діяльність на наших веб-сайтах, за винятком активності, коли ви
                        ввійшли в систему та розпочали терапію, може бути розкрита нашим рекламним партнерам для оптимізації
                        маркетингу. Ми не надаємо жодній рекламній платформі особисту інформацію, як імена учасників, адреси
                        електронної пошти, номери телефонів, діагнози, дані сеансів, записи, повідомлення, чи будь-який
                        інший тип спілкування, який ви маєте зі своїм терапевтом.
                    </p>
                    <p>Якщо ви хочете відмовитися від цих файлів cookie та веб-маяків</p>

                    <p><b>Відповідність закону:</b> ми можемо надати вашу інформацію суду, регулюючому органу, працівникам
                        правоохоронних органів або відповідно до повістки в суд для дотримання чинного законодавства або
                        будь-яких зобов’язань за ним. </p>

                    <p><strong>У контексті транзакції:</strong> ми можемо надати вашу інформацію у зв’язку з продажем
                        активів, злиттям, банкрутством або іншою бізнес-операцією.</p>

                    <p>З інших ділових причин: ми можемо надати вашу інформацію для забезпечення виконання будь-яких
                        застосовних Умов і положень і Умов використання, а також для забезпечення безпеки Платформи та наших
                        користувачів. Зауважте, що якщо ви робите будь-яку інформацію загальнодоступною на Платформі,
                        будь-хто може бачити та використовувати таку інформацію.
                    </p>

                    <h3>3. Відмова від маркетингових повідомлень </h3>

                    <p>Ви можете відмовитися від отримання маркетингових повідомлень електронною поштою, скасувавши підписку
                        за посиланням для скасування підписки, наданим у всіх наших маркетингових повідомленнях електронною
                        поштою.</p>

                    <a name="cookies" class=""></a>
                    <h3>4. Файли cookie та веб-маяки</h3>

                    <p>Як і багато веб-сайтів, ми використовуємо файли cookie та веб-маяки (також відомі як пікселі) для
                        збору інформації. "Cookie" - це невеликий файл даних, який передається на жорсткий диск вашого
                        комп'ютера з метою зберігання даних. Ми збираємо файли cookie, які необхідні для функціонування
                        Платформи, файли cookie, які підвищують продуктивність Платформи, і файли cookie, які
                        використовуються для відстеження третьою стороною. «Веб-маяк» — це крихітне та іноді невидиме
                        зображення або вбудований код, розміщений на веб-сторінці чи електронному листі, який може
                        повідомляти третій стороні про ваш візит або використання. Веб-маяки зазвичай використовуються
                        третіми сторонами для моніторингу активності користувачів на веб-сайті з метою веб-аналітики,
                        оптимізації реклами або позначення сторінок. Додаткову інформацію про веб-маяки можна знайти у
                        Вікіпедії. Ви можете змінити налаштування свого браузера, щоб він припинив приймати файли cookie та
                        веб-маяки або щоб запитувати вас перед прийняттям файлів cookie чи веб-маяка. Використання файлів
                        cookie, веб-маяків і подібних технологій для аналітики. Ми можемо використовувати сторонні файли
                        cookie або веб-маяки для цілей веб-аналітики, атрибуції та керування помилками. Наша Платформа може
                        використовувати служби постачальників, які використовують файли cookie, веб-маяки та подібні
                        технології, щоб збирати та зберігати анонімну інформацію про вас, зокрема, коли ви оплачуєте
                        послуги, завантажуєте сторінку, вказуєте, що ви чули про нас, підписуєтеся на послуги, введіть свою
                        платіжну інформацію (але деталі платежу не розголошуються), почніть заповнювати анкету та свою
                        відповідь щодо джерела направлення на Платформу. </p>

                    <p>Наша Платформа також використовує постачальників аналітичних засобів для збору інформації (наприклад,
                        даних про відвідувачів і даних реєстрації) про дії користувачів на наших веб-сайтах з метою
                        аналітики та аналізу певного використання Платформи. Використання файлів cookie, веб-маяків і
                        подібних технологій для рекламних мереж. Якщо ви погодитеся на використання цільових файлів cookie
                        та веб-маяків, ви та інші можете бачити певні оголошення наших послуг або Платформи на інших
                        веб-сайтах, оскільки ми беремо участь у рекламних мережах. Рекламні мережі дозволяють нам націлювати
                        наші повідомлення на користувачів за допомогою демографічних, на основі інтересів і контекстуальних
                        засобів. Ці мережі відстежують онлайн-діяльність людей протягом тривалого часу, збираючи інформацію
                        за допомогою автоматизованих засобів, зокрема за допомогою файлів cookie, журналів веб-сервера та
                        веб-маяків. Мережі використовують цю інформацію для показу реклами, яка може бути адаптована до
                        інтересів особи. Інформація, яку можуть збирати наші рекламні мережі, включає інформацію про ваші
                        відвідування веб-сайтів, які беруть участь у відповідних рекламних мережах, як сторінки чи рекламні
                        оголошення, які ви переглядаєте, і дії, які ви виконуєте на веб-сайтах. Цей збір даних відбувається
                        як на наших веб-сайтах, так і на веб-сайтах третіх осіб, які беруть участь у рекламних мережах. Цей
                        процес також допомагає нам відстежувати ефективність наших маркетингових зусиль і допомагає іншим
                        веб-сайтам і рекламним партнерам знайти вас або таких же людей на різних платформах, у тому числі на
                        веб-сайтах соціальних мереж.</p>

                    <p>
                        Інструменти соціальної та загальної інформації. Ми використовуємо декілька загальнодоступних
                        інструментів і ресурсів обміну інформацією, таких як (але не обмежуючись ними) блог і Facebook (?).
                        Будь-яка інформація, яку ви надаєте або ділитеся під час використання Інструментів соціальної та
                        загальної інформації, може бути прочитана, доступна, зібрана цим сайтом і користувачами цього сайту
                        відповідно до Політики конфіденційності.
                    </p>

                    <h3>6. Фішинг</h3>

                    <p>Крадіжка особистих даних і злом облікових записів в Інтернеті, включно з практикою, яка зараз відома
                        як «фішинг», викликають велике занепокоєння. Ви завжди повинні бути уважними, коли вас просять
                        надати інформацію вашого облікового запису, і ви завжди повинні переконатися, що ви робите це в
                        нашій безпечній системі. Ми ніколи не запитуватимемо вашу реєстраційну інформацію або дані вашої
                        кредитної картки в будь-якому незахищеному або небажаному повідомленні (електронною поштою,
                        телефоном чи іншим способом).</p>

                    <h3>7. Безпека інформації</h3>

                    <p>Ми вживаємо комерційно обґрунтовані заходи для захисту цілісності та конфіденційності особистої
                        інформації про здоров’я, якою ви можете поділитися з нами. Майте на увазі, що жодні заходи безпеки
                        не є досконалими чи непроникними, і ми не можемо гарантувати абсолютну безпеку вашої інформації. Ми
                        докладемо всіх зусиль, щоб захистити вашу інформацію, але ви також повинні захистити свої дані. Крім
                        того, ми не контролюємо дії будь-кого, з ким ви або будь-який інший користувач Anima можете
                        поділитися інформацією. Таким чином, ви повинні бути обережними щодо доступу, який ви надаєте іншим
                        під час використання Anima, і даних, які ви вирішуєте надати під час використання Anima.</p>

                    <h3>8. Постачальники послуг</h3>

                    <p>Ми можемо наймати сторонні компанії та осіб для сприяння роботі нашої Платформи, виконання певних
                        завдань, пов’язаних із Платформою, або для надання аудиторських, юридичних, операційних чи інших
                        послуг для нас. Ці завдання включають, але не обмежуються ними, обслуговування клієнтів, технічне
                        обслуговування, моніторинг, керування електронною поштою та зв’язок, керування базами даних,
                        виставлення рахунків і обробку платежів, звітність і аналітику. Ми будемо ділитися з ними лише
                        мінімально необхідною інформацією для виконання своїх завдань за нас і лише після укладення
                        відповідної угоди про конфіденційність.
                        Ми можемо надавати (або треті сторони можуть надавати) посилання на сторонні веб-сайти, служби або
                        ресурси поза нашим контролем. Ми не робимо заяв або схвалень щодо якості, придатності,
                        функціональності чи законності будь-якого стороннього вмісту, на який можуть надаватися посилання.
                        Цим ви відмовляєтеся від будь-яких претензій, які ви можете мати проти нас щодо таких послуг. ANIMA
                        НЕ НЕСЕ ВІДПОВІДАЛЬНОСТІ ЗА ВМІСТ В ІНТЕРНЕТІ АБО ВЕБ-СТОРІНКАХ, РОЗТАШОВАНИХ ЗА МЕЖАМИ ПЛАТФОРМИ.
                    </p>

                    <p>Ваші ділові відносини з третіми сторонами, виявлені на або через Платформу, включаючи оплату та
                        будь-які інші положення, умови, гарантії чи заяви, пов’язані з такими операціями, здійснюються
                        виключно між вами та такою третьою стороною. Ви погоджуєтеся з тим, що ми не несемо відповідальності
                        за будь-які втрати чи збитки, спричинені такими транзакціями, присутністю такої третьої сторони або
                        посиланнями на сторонні веб-сайти чи ресурси на Платформі.</p>

                    <h3>9. Дотримання законів і правоохоронна діяльність. </h3>

                    <p>Ми співпрацюємо з державними та правоохоронними органами для забезпечення виконання та дотримання
                        закону. Ми можемо розкривати інформацію, необхідну або відповідну для захисту громадської безпеки чи
                        будь-якої особи, для відповіді на претензії та судові процеси (включаючи, але не обмежуючись,
                        повістки до суду), а також для запобігання чи припинення діяльності, яка може бути незаконною чи
                        небезпечною. Ви також повинні знати, що наші спеціалісти можуть бути зобов’язані розкрити інформацію
                        правоохоронним або іншим органам для виконання своїх професійних і юридичних обов’язків. Зокрема,
                        але не обмежуючись, ви повинні знати, що закон вимагає від спеціалістів із психічного здоров’я
                        розкривати інформацію та/або вживати заходів у таких випадках: (a) повідомлення про жорстоке
                        поводження з дитиною чи вразливою дорослою особою або підозра на нього; (б) серйозний суїцидальний
                        потенціал; (в) загроза заподіяння шкоди іншій особі; (г) призначення лікування за рішенням суду.</p>

                    <h3>10. Зміни в Політиці конфіденційності</h3>

                    <p>Ми можемо оновлювати цю заяву про конфіденційність на власний розсуд. Дата останнього перегляду цієї
                        політики вказана в кінці цієї сторінки. Ми рекомендуємо вам періодично переглядати цю сторінку, щоб
                        отримати найновішу інформацію про нашу політику конфіденційності та практику. Незалежно від змін у
                        нашій Політиці конфіденційності, ми ніколи не використовуватимемо інформацію, яку ви надаєте згідно
                        з нашим поточним повідомленням про конфіденційність, у новий спосіб без попереднього сповіщення вас
                        і надання вам можливості припинити використання Платформи.</p>

                    <h3>11. Безпека</h3>
                    <p>Ми вживаємо комерційно обґрунтованих заходів для захисту цілісності та конфіденційності
                        ідентифікаційної інформації та інформації про здоров’я, якою ви можете поділитися з нами. Майте на
                        увазі, що жодні заходи безпеки не є досконалими або непроникними, і ми не можемо гарантувати
                        абсолютну безпеку вашої інформації. Ми зробимо свій внесок у захист вашої інформації, але вам також
                        важливо захистити свою інформацію. Крім того, ми не контролюємо дії будь-кого, з ким ви або
                        будь-який інший користувач Anima можете поділитися інформацією. Таким чином, ви повинні бути
                        обережними щодо доступу, який ви надаєте іншим під час використання Anima, та інформації, яку ви
                        вирішуєте надати під час використання Anima.</p>
                    <h3>11. Зв’язок з нами.</h3>

                    <p>Якщо у вас виникли запитання чи сумніви щодо цієї Політики конфіденційності або наших заходів,
                        пов’язаних із конфіденційністю, будь ласка, зв’яжіться з нами questions@anima.help. Якщо ви хочете
                        співпрацювати з нами, зв’яжіться з нами за адресою cooperation@anima.help.</p>

                    <a name="legal_npp" class="terms-item-link"></a>
                    <h2>Практика конфіденційності</h2>

                    <p>и можемо збирати такі види інформації, коли ви використовуєте Послуги:</p>

                    <p>Інформація, яку ви надаєте безпосередньо нам. Ми гарантуємо безпеку вашої інформації Для певних дій,
                        наприклад, коли ви реєструєтеся, користуєтеся нашими телемедичними послугами, підписуєтеся на наші
                        сповіщення або звертаєтесь до нас напряму, ми можемо збирати деякі або всі такі типи інформації:</p>

                    <ul>
                        <li>Контактна інформація, така як ваше повне ім’я, адреса електронної пошти, номер мобільного
                            телефону;
                        </li>
                        <li>Ім'я користувача та пароль;</li>
                        <li>платіжну інформацію, таку як номер вашої кредитної картки, термін дії та код безпеки кредитної
                            картки;
                        </li>
                        <li>Інформація про особисте здоров'я;</li>
                        <li>Будь-яка інша інформація, яку ви нам надаєте.</li>
                    </ul>

                    <p>Ми можемо поєднати таку інформацію з інформацією про вас, яку ми вже маємо.
                        Інформація, яку ми збираємо автоматично. Ми можемо автоматично збирати певну інформацію, коли ви
                        користуєтеся нашими Послугами, наприклад адресу вашого Інтернет-протоколу (IP), ідентифікатори
                        пристрою та реклами, тип браузера, операційну систему, постачальника послуг Інтернету, сторінки, які
                        ви відвідуєте до та після використання Послуг, дату і час вашого відвідування, інформацію про
                        посилання, які ви натискаєте, і сторінки, які ви переглядаєте в межах Послуг, а також іншу
                        стандартну інформацію сервера. Ми також можемо збирати певну інформацію про місцезнаходження, коли
                        ви користуєтеся нашими Послугами, наприклад IP-адресу вашого комп’ютера, сигнал GPS вашого
                        мобільного пристрою або інформацію про найближчі точки доступу WiFi і вежі стільникового зв’язку.
                    </p>
                    <p>Ми можемо використовувати файли cookie, теги пікселів, локальні спільні об’єкти та подібні технології
                        для автоматичного збору цієї інформації. Використовуючи послуги, ви погоджуєтесь на використання
                        файлів cookie та подібних технологій.</p>
                    <p>Ми також можемо збирати технічні дані для вирішення та усунення технічних проблем і покращення наших
                        Послуг, включаючи стан пам’яті вашого пристрою, коли під час користування нашими Послугами
                        відбувається збій системи або програми. Налаштування вашого пристрою або браузера може дозволити вам
                        контролювати збір цих технічних даних. Ці дані можуть містити частини документа, який ви
                        використовували, коли виникла проблема, або вміст ваших повідомлень. Використовуючи Послуги, ви
                        погоджуєтеся на збір цих технічних даних.</p>
                    <p></p>

                    <p>Цілями обробки отриманих від Вас персональних даних є:</p>

                    <ul>
                        <li>адміністрування Сервісу;</li>
                        <li>персоналізація сайту, що дозволяють отримувати Послуги в Сервісі;</li>
                        <li>направлення рахунків, нагадувань, повідомлень та повідомлень щодо Послуг, які є предметом
                            Договору
                        </li>
                        <li>розгляд запитів та скарг, зроблених Вами щодо роботи Сервісу;
                        </li>
                        <li>надсилання повідомлень електронною поштою, за здійсненими Вами запитами;</li>
                        <li>оцінка якості надання послуг;</li>
                        <li>оцінка використання різних функцій Сервісу;
                        </li>
                        <li>підвищення функціональності Сервісу та якості надання послуг;</li>
                        <li>визначення аудиторії Сервісу та статистики використання послуг, що надаються з використанням
                            Сервісу;
                        </li>
                        <li>забезпечення безпеки Сервісу та запобігання шахрайству;</li>
                        <li>статистичні та наукові цілі.</li>
                    </ul>

                    <p>Крім того, надані Вами дані можуть використовуватися адміністрацією з маркетинговою метою відповідно
                        до чинного законодавства України. При використанні даних користувача для прямого маркетингу
                        (комерційне розсилання та маркетингові повідомлення про нові послуги та пропозиції, які можуть бути
                        цікаві Користувачам), включається посилання, перейшовши яким користувач може відмовитися від
                        отримання таких повідомлень у майбутньому.</p>

                    <h3>Використання інформації</h3>
                    <p>
                        Зазвичай ми використовуємо інформацію, яку збираємо в Інтернеті, щоб:
                    </p>
                    <ul>
                        <li>Надавати та вдосконалювати Послуги;</li>
                        <li>Зв'язатися з вами;</li>
                        <li>Виконувати ваші запити на продукти, послуги та інформацію;
                        </li>
                        <li>Надсилати вам інформацію про додаткові клінічні послуги чи загальне оздоровлення від нас або від
                            імені наших афілійованих осіб і довірених сторонніх партнерів;
                        </li>
                        <li>Аналіз використання Сервісів і даних користувачів для розуміння та вдосконалення Сервісів;</li>
                        <li>Проводити дослідження з використанням вашої інформації, що може потребувати вашого окремого
                            письмового дозволу;
                        </li>
                        <li>Запобігаання потенційно забороненій або незаконній діяльності та іншим чином відповідно до наших
                            Умов використання
                        </li>
                        <li>Для будь-яких інших цілей, розкритих вам під час збору вашої інформації або за вашою згодою.
                        </li>
                    </ul>
                    <h3>Обмін інформацією</h3>

                    <p>Ми прагнемо зберегти вашу довіру та хочемо, щоб ви розуміли, коли та з ким ми можемо ділитися
                        інформацією, яку збираємо.</p>

                    <ul>
                        <li>Постачальники медичних послуг, страхові компанії та інші організації, пов’язані з охороною
                            здоров’я. Ми можемо ділитися вашою інформацією з іншими постачальниками медичних послуг,
                            лабораторіями, державними установами, страховими компаніями, організаціями, що займаються
                            закупівлею органів, судово-медичними експертами чи похоронними організаціями, а також іншими
                            організаціями, які пропонують варіанти лікування та підтримку.
                        </li>
                        <li>Авторизовані сторонні продавці та постачальники послуг. Ми можемо передавати вашу інформацію
                            стороннім постачальникам і постачальникам послуг, які допомагають нам із спеціалізованими
                            послугами, зокрема виставленням рахунків, обробкою платежів, обслуговуванням клієнтів,
                            розгортанням електронної пошти, бізнес-аналітикою, маркетингом (включаючи, але не обмежуючись
                            рекламою, атрибуцією, мобільним маркетингом, оптимізацією і ретаргетинг), моніторинг
                            продуктивності, хостинг і обробка даних. Ці сторонні постачальники та постачальники послуг не
                            можуть використовувати вашу інформацію для інших цілей, окрім тих, що пов’язані з послугами, які
                            вони нам надають.
                        </li>
                        <li>Партнери з дослідження. Ми можемо ділитися вашою інформацією з нашими дослідницькими партнерами
                            для проведення досліджень, пов’язаних зі здоров’ям; такий обмін може залежати від вашого
                            письмового дозволу.
                        </li>
                        <li>Корпоративні філії. Відповідно до цієї політики ми можемо ділитися вашою інформацією з нашими
                            корпоративними філіями.
                        </li>
                        <li>Перекази бізнесу. Ми можемо надати вашу інформацію у зв’язку зі значною корпоративною
                            транзакцією, такою як продаж веб-сайту, злиття, консолідація, продаж активів або у
                            малоймовірному випадку банкрутства.
                        </li>
                        <li>Правові цілі. Ми можемо розкривати інформацію у відповідь на повістки до суду, ухвали суду,
                            судові процеси, запити правоохоронних органів, судові претензії чи державні запити, а також для
                            захисту та захисту прав, інтересів, здоров’я, безпеки та безпеки American Well, наших філій,
                            користувачів , або громадськість. Припустімо, що ми за законом зобов’язані розкрити інформацію
                            про вас третій стороні. У такому випадку ми спробуємо повідомити вас, надіславши електронний
                            лист на електронну адресу, зазначену в наших записах, якщо це не порушить закон або ви не надали
                            нам свою електронну адресу.
                        </li>
                        <li>З вашої згоди або за вашим вказівкою. Ми можемо ділитися інформацією для будь-яких інших цілей,
                            розкритих вам під час збору інформації або за вашою згодою чи вказівкою.
                        </li>
                    </ul>

                    <p>За межами випадків використання, зазначених вище, ми не будемо надавати вашу інформацію третім
                        особам. Однак сторонні служби доступу, такі як Facebook або Google, через Послуги для входу в
                        Послуги або для обміну інформацією про ваш досвід користування Послугами з іншими. Ці сторонні
                        служби можуть збирати інформацію про вас, у тому числі інформацію про вашу діяльність на Сайті. Вони
                        можуть сповіщати ваші зв’язки зі сторонніми службами про використання вашого сайту відповідно до
                        своєї політики конфіденційності.</p>

                    <p>Якщо ви берете участь у публічній діяльності на Сайті або сторонніх сайтах, на які ми посилаємося, ви
                        повинні знати, що будь-яка інформація, яку ви надаєте там, може бути прочитана, зібрана або
                        використана іншими користувачами цих областей. Важливо бути обережним, розкриваючи особисту
                        інформацію під час участі на цих сайтах. Ми не несемо відповідальності за дані, які ви вирішите
                        надати в цих загальнодоступних місцях.</p>

                    <h3>Безпека</h3>

                    <p>Ми використовуємо розумні заходи, щоб допомогти захистити інформацію від втрати, крадіжки,
                        неправильного використання та несанкціонованого доступу, розголошення, зміни та знищення. Ви повинні
                        розуміти, що жодна система зберігання даних або передача даних через Інтернет чи будь-яку іншу
                        загальнодоступну мережу не може гарантувати 100-відсоткову безпеку. Зверніть увагу, що інформація,
                        зібрана третіми сторонами, може не мати такого захисту, як інформація, яку ви нам надсилаєте, і ми
                        не несемо відповідальності за захист такої інформації.</p>

                    <a name="legal_nnd" class="terms-item-link"></a>
                    <h2>Недискримінація</h2>

                    <p>Anima не дискримінує та не допускає дискримінації, включаючи, без обмеження, знущання, жорстоке
                        поводження чи переслідування, на основі фактичної чи передбачуваної раси, кольору шкіри, релігії,
                        національного походження, походження, віку, статі, фізичних або розумових вад, сексуальної
                        орієнтації , гендерної ідентичності, самовираження чи ВІЛ-статусу, або на основі зв’язку з іншою
                        особою через фактичну або передбачувану расу, колір шкіри, релігію, національне походження,
                        походження, вік, стать, фізичні чи розумові вади, сексуальну орієнтацію, гендерну ідентичність або
                        ВІЛ-статус.</p>

                    <p>Дата набрання чинності 21 серпеня 2022</p>

                </div>
            </div>
        </div>
    </section>
</ng-container>
<app-footer></app-footer>
